import moment from "moment";
import { store } from "redux/store";
import { API_STATUSES } from "../../_helpers/statuses";
import { API_CALLS } from "../_commonApiCalls/api";
import {
  setOldMessagesBackUpReduxState,
  setNewMessagesBackUpReduxState,
  deleteTeeSettingsStatusAction,
  getWeatherInfoDataStateAction,
  getWeatherInfoDataStatusAction,
  siteSettingsDataReduxStateAction,
  siteSettingsDataReduxStateStatusAction,
  getFeatureSetState,
  getFeatureSetStateStatus,
  setNewFeaturesStateAction,
  setNewFeaturesStatusAction,
  saveSharedTeeMarkerSettingsStatusAction,
  greenWithPinPlacementDataInfoReduxStateAction,
  getTodayPinPositionDataReduxStateAction,
  getTodayPinPositionDataReduxStatusAction,
  getActionZoneInfractionChildDataStateAction,
  getActionZoneInfractionChildDataStatusAction,
  loginUserData,
  mapInformationData,
  mapInformationStatus,
  getVerificationLinkData,
  getVerificationLinkStatus,
  resetUsernameData,
  resetUsernameStatus,
  changePasswordData,
  changePasswordStatus,
  resetPasswordData,
  resetPasswordStatus,
  setLoginUserStatus,
  getCarsDataAction,
  getCurrentCarsDataAction,
  getCarsStatusAction,
  getCarPathActionZoneAction,
  getCarPathActionZoneStatusAction,
  holeMarkerDataAction,
  holeMarkerStatusAction,
  getPrivilegesListAction,
  getPrivilegesListStatusAction,
  getPrivilegeAction,
  getPrivilegeStatusAction,
  getRolesListAction,
  getRolesListStatusAction,
  sendMessagesData,
  sendMessagesStatus,
  cannedMessagesData,
  cannedMessagesStatus,
  mapImageData,
  mapImageStatus,
  mapXYPointsData,
  mapXYPointsStatus,
  getCarHistoryData,
  getCarHistoryStatus,
  specificCarHistoryDataAction,
  specificCarHistoryStatusAction,
  allCarsHistoryDataAction,
  allCarsHistoryStatusAction,
  siteSettingsData,
  siteSettingsStatus,
  stagingModeDataAction,
  stagingModeStatusAction,
  saveEmailStatus,
  saveEmailData,
  deleteEmailStatus,
  deleteEmailData,
  alertMessageData,
  alertMessageStatus,
  sendTestEmailData,
  sendTestEmailStatus,
  updateEmailData,
  updateEmailStatus,
  kmlLayerData,
  kmlLayerDataStatus,
  messagesHistoryStatus,
  messagesHistoryData,
  fleetSettingsStatus,
  antiTamperSelectionStatus,
  fleetSettingsStatus2,
  fleetSettingslData,
  antiTamperSelectionData,
  fleetSettingslData2,
  getCarTrackData,
  getCarTrackStatus,
  getUserRole,
  getUserRoleStatus,
  carPropertiesData,
  carPropertiesStatus,
  carLocationData,
  carLocationStatus,
  carProductData,
  carProductStatus,
  siteLocationsStatus,
  siteLocationsData,
  updateCarStatus,
  updateCarTypeData,
  putCOGDataAction,
  putWelcomeScreenTextMessageAction,
  putWelcomeScreenTextMessageStatusAction,
  pinsApproachImagesStateDataAction,
  pinsApproachImagesStateStatusAction,
  carPinPlacementStateDataAction,
  carPinPlacementStateStatusAction,
  greensWithPinPlacementStateDataAction,
  greensWithPinPlacementStateStatusAction,
  deleteMessagesSettingStatus,
  deleteMessagesSettingData,
  rotationDataActions,
  rotationDataStatusActions,
  getRotationStateDataActions,
  getRotationDataStateStatusActions,
  saveCourseRotationDaysDataAction,
  saveCourseRotationDaysStatusAction,
  putScoreCardEmailStatusAction,
  putScoreCardEmailAction,
  putMaxHoleServicesStatus,
  putMaxHoleServicesAction,
  postSavePersistentCarTypeSettingStatus,
  postSavePersistentCarTypeSettingAction,
  putRemovePersistentCarTypeSettingStatus,
  putRemovePersistentCarTypeSettingAction,
  putDisableDistanceStatus,
  putDisableDistanceAction,
  putBehindPaceWarningStatus,
  putBehindPaceWarningAction,
  putPaceStatusTimeStatus,
  putPaceStatusTimeAction,
  putUpdatedLockStatus,
  putUpdatedLockAction,
  putUpdateMemberCarTrackingStatus,
  putUpdateMemberCarTrackingAction,
  putSiteOffStatus,
  putSiteOffAction,
  getRoundTimeOutState,
  getRoundTimeOutAction,
  putRoundTimeOutData,
  getMessagesFromCarsData,
  getMessagesFromCarsStatus,
  getPartialSiteSettingsStatus,
  getPartialSiteSettingsData,
  getProgressPendingForSiteStatus,
  getProgressPendingForSiteData,
  getVersionStringStatus,
  getVersionStringData,
  putMessagesSettingStatus,
  putMessagesSettingData,
  sendMessagesSettingStatus,
  sendMessagesSettingData,
  postHoleAreaData,
  postHoleAreaStatus,
  getScheduledFleetLockdownData,
  getScheduledFleetLockdownStatus,
  vduMessagesSettingStatus,
  vduMessagesSettingData,
  vduPutMessagesSettingData,
  vduPutMessagesSettingStatus,
  getCampaignsStatus,
  getCampaignsStateData,
  getAdImageStatusAction,
  getAdImageDataAction,
  getAdInsertImageStatusAction,
  getAdInsertImageDataAction,
  deleteCampaignData,
  deleteCampaignStatus,
  getImageGalleryStatusAction,
  getImageGalleryDataAction,
  putImageDescDataStatusAction,
  putImageDescDataAction,
  deleteImageDataStatusAction,
  deleteImageDataAction,
  resetPinsApproachImagesStateDataAction,
  saveCampaignDetailStatusAction,
  saveCampaignDetailDataAction,
  addNewCampaignStatusAction,
  addNewCampaignDataAction,
  saveWorksheetDataAction,
  saveWorksheetStatusAction,
  updatePinRotationStateDataAction,
  updatePinRotationStateDataStatusAction,
  copyCampaignsData,
  copyCampaignsStatus,
  deleteImagesStatus,
  deleteImagesData,
  deleteMultipleCampaignData,
  deleteMultipleCampaignStatus,
  saveTableCampaignDetailStatusAction,
  saveTableCampaignDetailDataAction,
  getBaseCampaignDataAction,
  getBaseCampaignStatusAction,
  getArchiveStatus,
  getArchiveData,
  addImageData,
  addImageStatus,
  getCarUsageDetailStatus,
  getCarUsageDetailState,
  getRoundsByCarDetailState,
  getRoundsByCarDetailStatus,
  addActionZoneStateAction,
  addActionZoneStatusAction,
  editActionZoneStateAction,
  editActionZoneStatusAction,
  deleteActionZoneStateAction,
  deleteActionZoneStatusAction,
  resetGetAdImageDataAction,
  siteSetupData,
  siteSetupStatus,
  publishSiteStatusAction,
  publishSiteDataAction,
  teeMarkerStatusAction,
  teeMarkerDataStateAction,
  poiMarkerStatusAction,
  poiMarkerDataStateAction,
  deleteTeeMarkerStatusAction,
  deleteTeeMarkerDataStateAction,
  deletePoiMarkerStatusAction,
  deletePoiMarkerDataStateAction,
  putPoiMarkerStatusAction,
  putPoiMarkerDataStateAction,
  putTeeMarkerStatusAction,
  putTeeMarkerDataStateAction,
  carBehindPaceDataStateAction,
  carBehindPaceDataStatusAction,
  putCOGDataStatusAction,
  putHoleAreaData,
  putHoleAreaDataStatus,
  putSiteAreaData,
  putSiteAreaDataStatus,
  deleteHoleAreaData,
  deleteHoleAreaStatus,
  deleteSiteAreaData,
  deleteSiteAreaStatus,
  getRoundsByDayStatus,
  getRoundsByDayState,
  postSiteAreaStatus,
  postSiteAreaDataState,
  getWelcomeAdsData,
  getWelcomeAdsDataStatus,
  getDashboardState,
  getDashboardRidingCarState,
  getDashboardStatus,
  getDispatchCarRidingStatus,
  getActionZoneInfractionDataStateActon,
  getActionZoneInfractionDataStatusAction,
  getCarSelectionStatusAction,
  getCarSelectionStateAction,
  dashboardPaceStatus,
  dashboardPaceData,
  publishSetupData,
  getSiteOffPeakCharginStatus,
  getSiteOffPeakCharginData,
  getCountCarBehindPaceStatusAction,
  getCountCarBehindPaceStateAction,
  getPaceByHoleState,
  getPaceByHoleStatus,
  getCarMovementState,
  getCarMovementStatus,
  getFleetReadinessState,
  getFleetReadinessStatus,
  getRoundsCompletedStatus,
  getRoundsCompletedState,
  getCarUsageStatus,
  getCarUsageState,
  getDashboardCampaignAdsStateAction,
  getDashboardCampaignAdsStatusAction,
  getDashboardFullImagesDataStateAction,
  getDashboardFullImagesDataStatusAction,
  getDashboardInsertImagesDataStateAction,
  getDashboardInsertImagesDataStatusAction,
  getDashboardCartPathDetailData,
  getDashboardCartPathDetailStatus,
  getResetDashboardDataStateAction,
  getResetInsertDashboardDataStateAction,
  getScoreCardState,
  getEmailAddressesState,
  getScoreCardStatus,
  getEmailAddressesStatus,
  putResendEmailState,
  putResendEmailStatus,
  getRoundsByCarStatus,
  getRoundsByCarState,
  getExportUsageStatus,
  getExportUsageState,
  getPreRoundCarsStatusAction,
  getPreRoundCarsStateAction,
  getDashboardBatteryNotificationStatusAction,
  getSiteAreasStateAction,
  getSiteAreasStatusAction,
  getHoleAreasStateAction,
  getHoleAreasStatusAction,
  getDashboardBatteryNotificationStateAction,
  setSiteSettingDataReduxStateAction,
  setSiteSettingDataReduxStateStatusAction,
  getExportRoundByCarState,
  getExportRoundByCarStatus,
  setClickToDriveApiDataAction,
  setClickToDriveApiStatusAction,
  getSingleCarTrackStateAction,
  getSingleCarTrackStatusAction,
  getDashboardFeatureSetStateAction,
  getDashboardFeatureSetStatusAction,
  putDashboardFeatureSetStatusAction,
  putDashboardFeatureSetStateAction,
  putCpoSettingsStateDataAction,
  putCpoSettingsStatusAction,
  setCustomerServiceProfileStatus,
  setCustomerServiceProfileData,
  saveCustomerServiceProfileSettingStatus,
  setSelectedInitialPinReduxStateAction,
  getFaultsStatus,
  getFaultsData,
  getFoodOrdersDataStateAction,
  getFoodOrdersDataStatusAction,
  getFoodImageDataStateAction,
  getFoodImageDataStatusAction,
  getFoodImageNamesDataStateAction,
  getFoodImageNamesDataStatusAction,
  getFoodOrdersTabDataStatusAction,
  getFoodOrdersTabDataStateAction,
  getFoodMenuTabDataStatusAction,
  getFoodMenuTabDataStateAction,
  putFoodMenuTabDataStatusAction,
  putFoodMenuTabDataStateAction,
  putFoodOrdersTabDataStateAction,
  putFoodOrdersTabDataStatusAction,
  putMessagesSettingData2,
  putMessagesSettingStatus2,
  setCourseChangesResponseAction,
  setCourseChangesStatusAction,
  putLocalisationStatus,
  putLocalisationState,
  setTeeMarkerSettingsStatusAction,
  setTeeMarkerSettingsDataAction,
  resetSiteDataVersionAction,
  resetSiteDataVersionStatusAction,
  sendMapDataAction,
  sendMapDataStatusAction,
  sendGreenViewDataAction,
  sendGreenViewDataStatusAction,
  getPackageManifestsData,
  getPackageManifestsStatus,
  assignManifestToCarsData,
  assignManifestToCarsStatus,
  sendSiteDataAction,
  sendSiteDataStatusAction,
  sendPOIDataAction,
  sendPOIDataStatusAction,
  scheduleSiteDataPublishAction,
  scheduleSiteDataPublishStatusAction,
  sendTeeMarkerDataAction,
  sendTeeMarkerDataStatusAction,
  clearSiteDataAction,
  clearSiteDataStatusAction,
  resetPOIsVersionAction,
  resetPOIsVersionStatusAction,
  resetMapsVersionAction,
  resetMapsVersionStatusAction,
  resetGreenViewVersionAction,
  resetGreenViewVersionStatusAction,
  resetTeeMarkersVersionAction,
  resetTeeMarkersVersionStatusAction,
  createSiteDataAction,
  createSiteDataStatusAction,
  resetSiteExtentsAndCtrPtToZeroAction,
  resetSiteExtentsAndCtrPtToZeroStatusAction,
  setSiteExtentsAction,
  setSiteExtentsStatusAction,
  disableAllAZsForMemberCarsAction,
  disableAllAZsForMemberCarsStatusAction,
  enableAllAZsForMemberCarsAction,
  enableAllAZsForMemberCarsStatusAction,
  getVisageUsersStatusAction,
  getVisageUsersAction,
  getVisagaUsersListAction,
  getVisagaUsersListStatusAction,
  addNewTeeMarkerSettingsStatusAction,
  addNewTeeMarkerSettingsDataAction,
  setSharedCheckboxSTatusReduxStateAction,
  setSharedCheckboxDataReduxStateAction,
  getValidateZoneDataStateAction,
  getValidateZoneDataStatusAction,
  getValidatePinDataStateAction,
  getValidatePinDataStatusAction,
  getSiteSettingStatusAction,
  getSiteSettingStateAction,
  getPaceManifestStatusAction,
  getPaceManifestStateAction,
  getMessageManifestStatusAction,
  getMessageManifestStateAction,
  getLanguageManifestStatusAction,
  getLanguageManifestStateAction,
  getSimpleCarManifestStatusAction,
  getSimpleCarManifestStateAction,
  getManifestListStatusAction,
  getManifestListStateAction,
  getChangePasswordStatusAction,
  getChangePasswordStateAction,
  teeMarkerLoaderStatusHandler,
  resetChangePasswordStateAction,
  getSettingListState,
  getSettingListStatus,
  getPaceListState,
  getPaceListStatus,
  getLanguageListState,
  getLanguageListStatus,
  getSimpleCarListState,
  getSimpleCarListStatus,
  getMessageListState,
  getMessageListStatus,
  putHoleDataStatusAction,
  putHoleDataStateAction,
  setAdminCodeStateAction,
  setAdminCodeStatusAction,
  setMessageStatusAction,
  setMessageStateAction,
  putRoundTimeOutStatusAction,
  uploadKmlDataStatusAction,
  uploadKmlDataStateAction,
  createHoleMapImageDataStateAction,
  createHoleMapImageDataStatusAction,
  processGreenViewDataStateAction,
  processGreenViewDataStatusAction,
  putMaxVolumeSettingStatusAction,
  sendMessageToMarshalsStatus,
  sendMessageToMarshalsData,
  setNewFoodOrderReduxState,
  setOldFoodOrderReduxState,
  getMinVersForNewAZsStatus,
  getMinVersForNewAZsData,
  publishWaiverTemplatesStatus,
  publishWaiverTemplatesData,
  saveWaiverTemplatesStatus,
  saveWaiverTemplatesData,
  getWaiverTemplatesStatus,
  getWaiverTemplatesData
} from "../_commonReducers/commonReducers";
import {
    setPinsImagesReduxStateDataAction,
    setAppDataReduxStateAction,
    setSiteSettingsDataAction,
    setPrintDataReduxStateAction,
    setOnlyMessagesReduxState,
} from "../_commonReducers/persistedLocalStorageReducer";

import {
    setSelectedMeasurementPinReduxStateAction,
    setSelectedMeasurementPinBackupReduxStateAction,
} from "../_commonReducers/persistedSessionStorageReducer";
import {
    APP_CONSTANTS_STATE,
    PINS_GLOBAL_STATE,
    MESSAGE_COUNT,
    FB_GLOBAL_STATES,
} from "../../../globalStore/globalStore";

// ======================================================== Headers Configuration Start ================================== //
export const headersConfigData = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        "Content-Type": "application/json",
        Authorization: "Basic " + credentialsData,
    };
};
export const headersConfigDataWelcomeAds = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Basic " + credentialsData,
    };
};

export const headersConfigDatafile = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        Authorization: "Basic " + credentialsData,
    };
};

const courseNumberGetter = () => {
    const { appDataReduxState: { courseNumber } = {} } =
        store.getState().firstReducer;
    if (courseNumber) {
        return courseNumber;
    }

    return null;
};

// ======================================================== Headers Configuration End ==================================== //

// ===================================================== Login Module Services Start ==================================================== //

const getAuthUserInfoServices = (userData) => {
    const { password, userName } = userData;
    return async function getUserData(dispatch) {
        dispatch(setLoginUserStatus(API_STATUSES.REQUEST));
        try {
            const credentials = window.btoa(userName + ":" + password);
            localStorage.setItem("vkey", credentials);

            let response = await API_CALLS.loginUser(userName, password);

            let jsonResponse = await response.json();

            if (jsonResponse?.success) {
                dispatch(loginUserData(jsonResponse));
                dispatch(setLoginUserStatus(API_STATUSES.SUCCESS));
            } else {
                dispatch(loginUserData(jsonResponse));
                dispatch(setLoginUserStatus(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(setLoginUserStatus(err));
        }
    };
};

const sendLinkToEmailForResetPasswordServices = (email) => {
    return async function sendVerification(dispatch) {
        dispatch(getVerificationLinkStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendLinkToEmailForResetPasswordApiCall(email);

            let jsonResponse = await response.json();

            dispatch(getVerificationLinkData(jsonResponse));
            dispatch(getVerificationLinkStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getVerificationLinkStatus(err));
        }
    };
};

const resetUsernameServices = (email) => {
    return async function resetUsername(dispatch) {
        dispatch(resetUsernameStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetUsernameApiCall(email);
            let jsonResponse = await response.json();

            dispatch(resetUsernameData(jsonResponse));
            dispatch(resetUsernameStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetUsernameStatus(err));
        }
    };
};

const changePasswordServices = (newPass, uname) => {
    return async function changePassword(dispatch) {
        dispatch(changePasswordStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.changePasswordApiCall(newPass, uname);
            let jsonResponse = await response.json();

            dispatch(changePasswordData(jsonResponse));
            dispatch(changePasswordStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(changePasswordStatus(err));
        }
    };
};

const resetPasswordServices = (newPassword, passwordResetToken) => {
    return async function resetPassword(dispatch) {
        dispatch(resetPasswordStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetPasswordApiCall(newPassword, passwordResetToken);
            let jsonResponse = await response.json();
            dispatch(resetPasswordData(jsonResponse));
            dispatch(resetPasswordStatus(response.ok ? API_STATUSES.SUCCESS : API_STATUSES.ERROR));
        } catch (err) {
            dispatch(resetPasswordData(err));
            dispatch(resetPasswordStatus(API_STATUSES.ERROR));
        }
    };
};

// ===================================================== Login Module Services End ==================================================== //

// ===================================================== Map Module Services Start ==================================================== //

const getCarServices = (firstLoad = false, siteId) => {
    if (window.location.pathname !== "/pins") {
        let initialDate = moment(0).utc().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        let todayDate = localStorage.getItem("lastCarsQueryDate") !== undefined || null
            ? localStorage.getItem("lastCarsQueryDate")
            : moment(0).utc().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        let queryDate = firstLoad ? initialDate : todayDate;

        return async function getCars(dispatch) {
            dispatch(getCarsStatusAction(API_STATUSES.REQUEST));
            try {
                let response = await API_CALLS.getCarsApiCall(
                    queryDate,
                    headersConfigData,
                    siteId
                );
                if (queryDate === initialDate) {
                    APP_CONSTANTS_STATE.getCarsCounter.set(1);
                    let jsonResponse = await response.json();
                    dispatch(getCarsDataAction(jsonResponse));
                    dispatch(getCarsStatusAction(API_STATUSES.SUCCESS));
                    return jsonResponse;
                } else {
                    APP_CONSTANTS_STATE.getCarsCounter.set(
                        APP_CONSTANTS_STATE.getCarsCounter.get() + 1
                    );
                    let jsonResponse = await response.json();
                    dispatch(getCurrentCarsDataAction(jsonResponse));
                    dispatch(getCarsStatusAction(API_STATUSES.SUCCESS));
                }
            } catch (err) {
                dispatch(getCarsStatusAction(err));
            }
        };
    }

    return () => {};
};

const setClickToDriveServices = (carIds, carLat, carLng, siteId) => {
    return async function setClickToDrive(dispatch) {
        dispatch(setClickToDriveApiStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.clickToDriveApiCall(
                carIds,
                carLat,
                carLng,
                siteId,
                headersConfigData
            );

            let jsonResponse = await response.json();

            dispatch(setClickToDriveApiDataAction(jsonResponse));
            dispatch(setClickToDriveApiStatusAction(API_STATUSES.SUCCESS));

            return jsonResponse;
        } catch (err) {
            dispatch(setClickToDriveApiStatusAction(err));
        }
    };
};

const getActionZoneServices = (siteId) => {
    return async function getActionZones(dispatch) {
        dispatch(getCarPathActionZoneStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getActionZoneApiCall(headersConfigData, siteId);

            let jsonResponse = await response.json();

            dispatch(getCarPathActionZoneAction(jsonResponse));
            dispatch(getCarPathActionZoneStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarPathActionZoneStatusAction(err));
        }
    };
};

const getFaultsServices = (siteId) => {
    if (window.location.pathname !== "/pins") {
        return async function getFaults(dispatch) {
            dispatch(getFaultsStatus(API_STATUSES.REQUEST));
            try {
                let response = await API_CALLS.getFaultsCall(headersConfigData, siteId);
                let jsonResponse = await response.json();

                dispatch(getFaultsData(jsonResponse));
                dispatch(getFaultsStatus(API_STATUSES.SUCCESS));
            } catch (err) {
                dispatch(getFaultsStatus(err));
            }
        };
    }
};

const getHoleMarkerServices = (siteId) => {
    return async function getHoleMarkers(dispatch) {
        dispatch(holeMarkerStatusAction(API_STATUSES.REQUEST));

        try {
            let response = await API_CALLS.getHoleMarkerApiCall(headersConfigData, siteId);

            let jsonResponse = await response.json();

            dispatch(holeMarkerDataAction(jsonResponse));
            dispatch(holeMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(holeMarkerStatusAction(err));
        }
    };
};

const getKmlLayerService = (siteId) => {
    return async function getKmlLayer(dispatch) {
        dispatch(kmlLayerDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setkmlLayerApiCall(headersConfigData, siteId);

            let jsonResponse = await response.json();

            dispatch(kmlLayerData(jsonResponse));
            dispatch(kmlLayerDataStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(kmlLayerDataStatus(err));
        }
    };
};

const sendMessagesServices = (msgInput, Options, gpsiCarId, siteId) => {
  return async function sendMessages(dispatch) {
    dispatch(sendMessagesStatus(API_STATUSES.REQUEST));
    try {
      let response = await API_CALLS.sendMessagesApiCall(
        msgInput,
        Options,
        gpsiCarId,
        siteId,
        headersConfigData
      );

            let jsonResponse = await response.json();

            dispatch(sendMessagesData(jsonResponse));
            dispatch(sendMessagesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendMessagesStatus(err));
        }
    };
};

const getCannedMessagesServices = (siteId) => {
    return async function getCannedMessages(dispatch) {
        dispatch(cannedMessagesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCannedMessagesApiCall(
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();

            dispatch(cannedMessagesData(jsonResponse));
            dispatch(cannedMessagesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(cannedMessagesStatus(err));
        }
    };
};

const getMapImageServices = (siteId) => {
    return async function getMapImage(dispatch) {
        dispatch(mapImageStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMapImageApiCall(
                headersConfigData,
                parseInt(siteId)
            );

            let jsonResponse = await response.json();

            dispatch(mapImageData(jsonResponse));
            dispatch(mapImageStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(mapImageStatus(err));
        }
    };
};

const getXYPointsInImageServices = (mapImageXYPointsRequest) => {
    return async function getXYPointsInImage(dispatch) {
        dispatch(mapXYPointsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getXYPointsInImageApiCall(
                headersConfigData,
                mapImageXYPointsRequest
            );

            let jsonResponse = await response.json();

            dispatch(mapXYPointsData(jsonResponse));
            dispatch(mapXYPointsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(mapXYPointsStatus(err));
        }
    };
};

const getCarHistoryServices = (lastQueryDate, siteId) => {
    return async function getCarHistory(dispatch) {
        dispatch(getCarHistoryStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarHistoryApiCall(
                lastQueryDate,
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();

            dispatch(getCarHistoryData(jsonResponse));
            dispatch(getCarHistoryStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarHistoryStatus(err));
        }
    };
};

const getSpecificCarHistoryServices = (carNumber, date, siteId) => {
    return async function getSpecificCarHistory(dispatch) {
        dispatch(specificCarHistoryStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSpecificCarHistory(
                carNumber,
                date,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            if (jsonResponse) {
                dispatch(specificCarHistoryDataAction(jsonResponse));
            } else {
                dispatch(specificCarHistoryDataAction([]));
            }
            setTimeout(() => {
                dispatch(specificCarHistoryStatusAction(API_STATUSES.SUCCESS));
            }, 1000);
        } catch (err) {
            dispatch(specificCarHistoryStatusAction(err));
            dispatch(specificCarHistoryDataAction([]));
        }
    };
};

// ====================================== Site Data Configuration Service Start =========================================//

const enableAllAZsForMemberCarsServices = (siteId) => {
    return async function enableAllAZsForMemberCars(dispatch) {
        dispatch(enableAllAZsForMemberCarsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.enableAllAZsForMemberCarsApiCall(
                parseInt(siteId),
                headersConfigData
            );

            let jsonResponse = await response.json();

            dispatch(enableAllAZsForMemberCarsAction(jsonResponse));
            dispatch(enableAllAZsForMemberCarsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(enableAllAZsForMemberCarsStatusAction(err));
        }
    };
};

const disableAllAZsForMemberCarsServices = (siteId) => {
    return async function disableAllAZsForMemberCars(dispatch) {
        dispatch(disableAllAZsForMemberCarsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.disableAllAZsForMemberCarsApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(disableAllAZsForMemberCarsAction(jsonResponse));
            dispatch(disableAllAZsForMemberCarsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(disableAllAZsForMemberCarsStatusAction(err));
        }
    };
};

const resetSiteExtentsAndCtrPtToZeroServices = (siteId) => {
    return async function resetSiteExtentsAndCtrPtToZero(dispatch) {
        dispatch(resetSiteExtentsAndCtrPtToZeroStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetSiteExtentsAndCtrPtToZeroApiCall(
                parseInt(siteId),
                headersConfigData
            );

            let jsonResponse = await response.json();

            dispatch(resetSiteExtentsAndCtrPtToZeroAction(jsonResponse));
            dispatch(resetSiteExtentsAndCtrPtToZeroStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetSiteExtentsAndCtrPtToZeroStatusAction(err));
        }
    };
};

const setSiteExtentsServices = (payload) => {
    return async function setSiteExtents(dispatch) {
        dispatch(setSiteExtentsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setSiteExtentsApiCall(
                payload,
                headersConfigData
            );

            let jsonResponse = await response.json();

            dispatch(setSiteExtentsAction(jsonResponse));
            dispatch(setSiteExtentsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setSiteExtentsStatusAction(err));
        }
    };
};

const getVisageUsersServices = () => {
    return async function getVisageUsers(dispatch) {
        dispatch(getVisageUsersStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getVisageUsersApiCall(headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getVisageUsersAction(jsonResponse));
            dispatch(getVisageUsersStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getVisageUsersStatusAction(err));
        }
    };
};

const getVisageUsersList = () => {
    return async function getVisageUsersList(dispatch) {
        dispatch(getVisagaUsersListStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getVisageUsersListApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getVisagaUsersListAction(jsonResponse));
            dispatch(getVisagaUsersListStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getVisagaUsersListStatusAction(err));
        }
    };
};

const getRolesListServices = () => {
    return async function getRolesList(dispatch) {
        dispatch(getRolesListStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRolesListApiCall(headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getRolesListAction(jsonResponse));
            dispatch(getRolesListStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRolesListStatusAction(err));
        }
    };
};

const getPrivilegesListServices = () => {
    return async function getPrivilegesList(dispatch) {
        dispatch(getPrivilegesListStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPrivilegesListApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getPrivilegesListAction(jsonResponse));
            dispatch(getPrivilegesListStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPrivilegesListStatusAction(err));
        }
    };
};

const getPrivilegeServices = (privilege) => {
    return async function getPrivilege(dispatch) {
        dispatch(getPrivilegeStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPrivilegeApiCall(
                privilege,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getPrivilegeAction(jsonResponse));
            dispatch(getPrivilegeStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPrivilegeStatusAction(err));
        }
    };
};

const createSiteDataServices = (payload) => {
    return async function createSiteData(dispatch) {
        dispatch(createSiteDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.createSiteDataApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(createSiteDataAction(jsonResponse));
            dispatch(createSiteDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(createSiteDataStatusAction(err));
        }
    };
};

const resetTeeMarkersVersionServices = (payload) => {
    return async function resetTeeMarkersVersion(dispatch) {
        dispatch(resetTeeMarkersVersionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetTeeMarkersVersionApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(resetTeeMarkersVersionAction(jsonResponse));
            dispatch(resetTeeMarkersVersionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetTeeMarkersVersionStatusAction(err));
        }
    };
};

const resetMapsVersionServices = (payload) => {
    return async function resetMapsVersion(dispatch) {
        dispatch(resetMapsVersionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetMapsVersionApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(resetMapsVersionAction(jsonResponse));
            dispatch(resetMapsVersionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetMapsVersionStatusAction(err));
        }
    };
};

const resetGreenViewVersionServices = (payload) => {
    return async function resetGreenViewVersion(dispatch) {
        dispatch(resetGreenViewVersionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetGreenViewVersionApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(resetGreenViewVersionAction(jsonResponse));
            dispatch(resetGreenViewVersionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetGreenViewVersionStatusAction(err));
        }
    };
};

const resetPOIsVersionServices = (payload) => {
    return async function resetPOIsVersion(dispatch) {
        dispatch(resetPOIsVersionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetPOIsVersionApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(resetPOIsVersionAction(jsonResponse));
            dispatch(resetPOIsVersionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetPOIsVersionStatusAction(err));
        }
    };
};

const clearSiteDataServices = (payload) => {
    return async function clearSiteData(dispatch) {
        dispatch(clearSiteDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.clearSiteDataApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(clearSiteDataAction(jsonResponse));
            dispatch(clearSiteDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(clearSiteDataStatusAction(err));
        }
    };
};

const sendTeeMarkerDataServices = (siteId) => {
    return async function sendTeeMarkerData(dispatch) {
        dispatch(sendTeeMarkerDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendTeeMarkerDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendTeeMarkerDataAction(jsonResponse));
            dispatch(sendTeeMarkerDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendTeeMarkerDataStatusAction(err));
        }
    };
};

const scheduleSiteDataPublishServices = (siteId) => {
    return async function scheduleSiteDataPublish(dispatch) {
        dispatch(scheduleSiteDataPublishStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.scheduleSiteDataPublishApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(scheduleSiteDataPublishAction(jsonResponse));
            dispatch(scheduleSiteDataPublishStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(scheduleSiteDataPublishStatusAction(err));
        }
    };
};

const sendPOIDataServices = (siteId) => {
    return async function sendPOIData(dispatch) {
        dispatch(sendPOIDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendPOIDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendPOIDataAction(jsonResponse));
            dispatch(sendPOIDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendPOIDataStatusAction(err));
        }
    };
};

const sendSiteDataServices = (siteId) => {
    return async function sendSiteData(dispatch) {
        dispatch(sendSiteDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendSiteDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendSiteDataAction(jsonResponse));
            dispatch(sendSiteDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendSiteDataStatusAction(err));
        }
    };
};

const sendMapDataServices = (siteId) => {
    return async function sendMapData(dispatch) {
        dispatch(sendMapDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.SendMapDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendMapDataAction(jsonResponse));
            dispatch(sendMapDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendMapDataStatusAction(err));
        }
    };
};

const sendGreenViewDataServices = (siteId) => {
    return async function sendGreeViewData(dispatch) {
        dispatch(sendGreenViewDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendGreenViewDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendGreenViewDataAction(jsonResponse));
            dispatch(sendGreenViewDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendGreenViewDataStatusAction(err));
        }
    };
};

const resetSiteDataVersionServices = (payload) => {
    return async function resetSiteDataVersion(dispatch) {
        dispatch(resetSiteDataVersionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.resetSiteDataVersionApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(resetSiteDataVersionAction(jsonResponse));
            dispatch(resetSiteDataVersionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(resetSiteDataVersionStatusAction(err));
        }
    };
};

// ====================================== Site Data Configuration Service End =========================================//

const getAllCarsHistoryServices = () => {
    return async function getAllCarsHistory(dispatch) {
        dispatch(allCarsHistoryStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarHistoryForAllCars();
            let jsonResponse = await response.json();

            dispatch(allCarsHistoryDataAction(jsonResponse));
            dispatch(allCarsHistoryStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(allCarsHistoryStatusAction(err));
        }
    };
};

const getUserNameAndRoles = () => {
    return async function getUserNameRole(dispatch) {
        dispatch(getUserRoleStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getUserNameAndRole(headersConfigData);
            let jsonResponse = await response.json();
            dispatch(getUserRole(jsonResponse));
            dispatch(getUserRoleStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getUserRoleStatus(err));
        }
    };
};

const getCarTrackServices = (payload, siteId) => {
    return async function getTrack(dispatch) {
        dispatch(getCarTrackStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarTrackApiCall(
                payload,
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();
            dispatch(getCarTrackData(jsonResponse));
            dispatch(getCarTrackStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarTrackStatus(err));
        }
    };
};

const getCarProperties = (siteId) => {
    return async function getCarProp(dispatch) {
        dispatch(carPropertiesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarPropertiesApiCall(headersConfigData, siteId);
            let jsonResponse = await response.json();

            dispatch(carPropertiesData(jsonResponse));
            dispatch(carPropertiesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(carPropertiesStatus(API_STATUSES.ERROR));
        }
    };
};

const getCarLocation = (siteId) => {
    return async function getCarLocation(dispatch) {
        dispatch(carLocationStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarLocationApicall(headersConfigData, siteId);
            let jsonResponse = await response.json();

            dispatch(carLocationData(jsonResponse));
            dispatch(carLocationStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(carLocationStatus(API_STATUSES.ERROR));
        }
    };
};

const getProductData = (payload) => {
    return async function getProductData(dispatch) {
        dispatch(carProductStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getProductApicall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(carProductData(jsonResponse));
            dispatch(carProductStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(carProductStatus(API_STATUSES.ERROR));
        }
    };
};

const updateCarType = (payload) => {
    return async (dispatch) => {
        dispatch(updateCarStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updateCarTypeApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(updateCarTypeData(jsonResponse));
            dispatch(updateCarStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(updateCarStatus(err));
        }
    };
};

// ===================================================== Map Module Services End ==================================================== //

// ===================================================== Fleet Module Services Start ==================================================== //

const getSiteSettingsServices = (siteId) => {
    return async function getSiteSettings(dispatch) {
        dispatch(siteSettingsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteSettingsApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(siteSettingsData(jsonResponse));
            dispatch(siteSettingsStatus(API_STATUSES.SUCCESS));
            dispatch(siteSettingsDataReduxStateAction(jsonResponse));
            dispatch(siteSettingsDataReduxStateStatusAction(API_STATUSES.SUCCESS));
            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "sitenumber",
                    value: jsonResponse?.Id,
                })
            );

            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "coursesdata",
                    value: jsonResponse?.Courses,
                })
            );

            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "coursenumber",
                    value: jsonResponse?.Courses[0]?.Number,
                })
            );

            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "coursename",
                    value: jsonResponse?.Courses[0]?.Name,
                })
            );

            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "sitename",
                    value: jsonResponse?.Name,
                })
            );

            dispatch(
                setAppDataReduxStateAction({
                    parameterDetector: "distanceunits",
                    value: jsonResponse?.DistanceUnits,
                })
            );

            dispatch(setSiteSettingsDataAction(jsonResponse));
            dispatch(setSiteSettingDataReduxStateAction(jsonResponse));
            dispatch(setSiteSettingDataReduxStateStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(siteSettingsStatus(err));
            dispatch(setSiteSettingDataReduxStateStatusAction(API_STATUSES.ERROR));
        }
    };
};

const getTodayPinPositionServices = (courseNumId, siteId) => {
    return async function getTodayPinPositionCaller(dispatch) {
        dispatch(getTodayPinPositionDataReduxStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getTodayPinPosition(
                headersConfigData,
                siteId,
                courseNumId
                // courseNumberGetter
            );
            let jsonResponse = await response.json();
            dispatch(getTodayPinPositionDataReduxStateAction(jsonResponse));
        } catch (error) {
            dispatch(getTodayPinPositionDataReduxStatusAction(API_STATUSES.ERROR));
        }
    };
};

const getScheduledFleetLockdownServices = (RecId, siteId) => {
    return async function getScheduledFleetLockdown(dispatch) {
        dispatch(getScheduledFleetLockdownStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getScheduledFleetLockdownApiCall(
                RecId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getScheduledFleetLockdownData(jsonResponse));
            dispatch(getScheduledFleetLockdownStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getScheduledFleetLockdownStatus(err));
        }
    };
};

const getSiteOffPeakCharginServices = (RecId, siteId) => {
    return async function getSiteOffPeakChargin(dispatch) {
        dispatch(getSiteOffPeakCharginStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteOffPeakCharginApiCall(
                RecId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getSiteOffPeakCharginData(jsonResponse));
            dispatch(getSiteOffPeakCharginStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSiteOffPeakCharginStatus(err));
        }
    };
};

const getDashboardCartPathDetailServices = (siteId, courseId) => {
    return async function getDashboardCartPathDetail(dispatch) {
        dispatch(getDashboardCartPathDetailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardCartPathDetailApiCall(
                headersConfigData,
                siteId,
                courseId
            );
            let jsonResponse = await response.json();
            dispatch(getDashboardCartPathDetailData(jsonResponse));
            dispatch(getDashboardCartPathDetailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getDashboardCartPathDetailStatus(err));
        }
    };
};

const getWelcomeAdsImageServices = (siteId) => {
    return async function getWelcomeAdsImage(dispatch) {
        dispatch(getWelcomeAdsDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getWelcomeAdsApiCall(
                headersConfigDataWelcomeAds,
                siteId
            );

            let imageBlob = await response.blob();
            let reader = new FileReader();
            reader.readAsDataURL(imageBlob);

            reader.onloadend = () => {
                let base64data = reader.result;
                dispatch(getWelcomeAdsData({ base64data }));
                dispatch(getWelcomeAdsDataStatus(API_STATUSES.SUCCESS));
            };
        } catch (err) {
            dispatch(getWelcomeAdsDataStatus(err));
        }
    };
};

const purCarStagingGuardianModeServices = (siteSettingData, siteId) => {
    return async function getCarStagingMode(dispatch) {
        dispatch(stagingModeStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.carStagingModeAPICall(
                siteSettingData,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(stagingModeDataAction(jsonResponse));
            dispatch(stagingModeStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(stagingModeStatusAction(err));
        }
    };
};

const putWelcomeScreenTextMessageServices = (textMessage, siteId) => {
    return async function putWelcomeScreenTextMessage(dispatch) {
        dispatch(putWelcomeScreenTextMessageStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendFleetSettingsWelcomeText(
                textMessage,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putWelcomeScreenTextMessageAction(jsonResponse));
            dispatch(putWelcomeScreenTextMessageStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putWelcomeScreenTextMessageStatusAction(err));
        }
    };
};

const putCOGDataServices = (payload, cogId, siteId) => {
    return async function putCOGData(dispatch) {
        dispatch(putCOGDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putCOGData(
                payload,
                siteId,
                cogId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putCOGDataAction(jsonResponse));
            dispatch(putCOGDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putCOGDataStatusAction(err));
        }
    };
};

const putHoleAreaDataServices = (payload, Id, siteId) => {
    return async function putHoleAreaDataFunc(dispatch) {
        dispatch(putHoleAreaDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putHoleAreaApiCall(
                payload,
                Id,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putHoleAreaData(jsonResponse));
            dispatch(putHoleAreaDataStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putHoleAreaDataStatus(err));
        }
    };
};

const putSiteAreaDataServices = (payload, Id, siteId) => {
    return async function putSiteAreaDataFunc(dispatch) {
        dispatch(putSiteAreaDataStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putSiteAreaApiCall(
                payload,
                Id,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putSiteAreaData(jsonResponse));
            dispatch(putSiteAreaDataStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putSiteAreaDataStatus(err));
        }
    };
};

const putScoreCardEmailServices = (email, siteId) => {
    return async function putScoreCardEmail(dispatch) {
        dispatch(putScoreCardEmailStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendScoreCardEmail(
                email,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putScoreCardEmailAction(jsonResponse));
            dispatch(putScoreCardEmailStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putScoreCardEmailStatusAction(err));
        }
    };
};

const putMaxHoleServices = (mhAlert, siteId) => {
    return async function putMaxHoles(dispatch) {
        dispatch(putMaxHoleServicesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMaxHolesExAlert(
                mhAlert,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putMaxHoleServicesAction(jsonResponse));
            dispatch(putMaxHoleServicesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putMaxHoleServicesStatus(err));
        }
    };
};

const putDisableDistanceServices = (mhDisableDist, siteId) => {
    return async function putDisableDistance(dispatch) {
        dispatch(putDisableDistanceStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putDisableDistance(
                mhDisableDist,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putDisableDistanceAction(jsonResponse));
            dispatch(putDisableDistanceStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putDisableDistanceStatus(err));
        }
    };
};
const putBehindPaceWarningServices = (bpWarning, siteId) => {
    return async function putBehindPaceWarning(dispatch) {
        dispatch(putBehindPaceWarningStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putBehindPaceWarning(
                bpWarning,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putBehindPaceWarningAction(jsonResponse));
            dispatch(putBehindPaceWarningStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putBehindPaceWarningStatus(err));
        }
    };
};
const putPaceStatusTimeServices = (paceStatus, siteId) => {
  return async function putPaceStatusTime(dispatch) {
    dispatch(putPaceStatusTimeStatus(API_STATUSES.REQUEST));
    try {
      let response = await API_CALLS.putPaceStatusTime(
        paceStatus,
        siteId,
        headersConfigData
      );
      let jsonResponse = await response.json();
      dispatch(putPaceStatusTimeAction(jsonResponse));
      dispatch(putPaceStatusTimeStatus(API_STATUSES.SUCCESS));
    } catch (err) {
      dispatch(putPaceStatusTimeStatus(err));
    }
  };
};
const putUpdateScheduleLockDownServices = (payload, siteId) => {
    return async function putUpdate(dispatch) {
        dispatch(putUpdatedLockStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putUpdateScheduleLockDown(
                payload,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putUpdatedLockAction(jsonResponse));
            dispatch(putUpdatedLockStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putUpdatedLockStatus(err));
        }
    };
};

const putUpdateMemberCarTrackingLevelServices = (payload, siteId) => {
    return async function putUpdateMemberCarTracking(dispatch) {
        dispatch(putUpdateMemberCarTrackingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updateMemberCarTrackingLevelApiCall(
                payload,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putUpdateMemberCarTrackingAction(jsonResponse));
            dispatch(putUpdateMemberCarTrackingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putUpdateMemberCarTrackingStatus(err));
        }
    };
};

const putSiteOffPeakChargingServices = (payload, siteId) => {
    return async function putSiteOffPeak(dispatch) {
        dispatch(putSiteOffStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putSiteOffPeakCharging(
                payload,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putSiteOffAction(jsonResponse));
            dispatch(putSiteOffStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putSiteOffStatus(err));
        }
    };
};

const putMaxHolesNumService = (holeValue, siteId) => {
    return async function putMax(dispatch) {
        dispatch(putMaxHoleServicesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMaxNumHoles(
                holeValue,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putMaxHoleServicesAction(jsonResponse));
            dispatch(putMaxHoleServicesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putMaxHoleServicesStatus(err));
        }
    };
};

const postSavePersistentCarTypeSettingService = (siteId, carNumber, carType, isPersistCarType) => {
    return async function postSavePersistentCarTypeSetting(dispatch) {
        dispatch(postSavePersistentCarTypeSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postSavePersistentCarTypeSetting(
                siteId, 
                carNumber, 
                carType, 
                isPersistCarType,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(postSavePersistentCarTypeSettingAction(jsonResponse));
            dispatch(postSavePersistentCarTypeSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(postSavePersistentCarTypeSettingStatus(err));
        }
    };
};
const putRemovePersistentCarTypeSettingService = (siteId, carNumber, carType) => {
    return async function putRemovePersistentCarTypeSetting(dispatch) {
        dispatch(putRemovePersistentCarTypeSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putRemovePersistentCarTypeSetting(
                siteId, 
                carNumber, 
                carType,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putRemovePersistentCarTypeSettingAction(jsonResponse));
            dispatch(putRemovePersistentCarTypeSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putRemovePersistentCarTypeSettingStatus(err));
        }
    };
};

const getRoundTimeOutServices = (siteId) => {
    return async function getRoundTime(dispatch) {
        dispatch(getRoundTimeOutState(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRoundTimeOutApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getRoundTimeOutAction(jsonResponse));
            dispatch(getRoundTimeOutState(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRoundTimeOutAction({}));
            dispatch(getRoundTimeOutState(err));
        }
    };
};

const putRoundTimeOutServices = (payload, siteId) => {
    return async function putRoundTimeout(dispatch) {
        dispatch(putRoundTimeOutStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putRoundStagingTimeoutApi(
                payload,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putRoundTimeOutData(jsonResponse));
            dispatch(putRoundTimeOutStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putRoundTimeOutStatusAction(err));
        }
    };
};

const getMessagesFromCarsServices = (oldest, siteId) => {
    if (window.location.pathname !== "/pins") {
        return async function getMessageFromCarsfn(dispatch) {
            dispatch(getMessagesFromCarsStatus(API_STATUSES.REQUEST));
            try {
                let response = await API_CALLS.getMessagesFromCarsApi(
                    siteId,
                    moment(oldest).toISOString(),
                    headersConfigData
                );

                let jsonResponse = await response.json();

                dispatch(getMessagesFromCarsData(jsonResponse));
                dispatch(setOnlyMessagesReduxState(jsonResponse?.Messages));
                dispatch(setNewMessagesBackUpReduxState(jsonResponse?.Messages));
                dispatch(getMessagesFromCarsStatus(API_STATUSES.SUCCESS));
                if (MESSAGE_COUNT.MessageSoundRingerDetector.get() === 0) {
                    dispatch(setOldMessagesBackUpReduxState(jsonResponse?.Messages));
                }
                MESSAGE_COUNT.MessageSoundRingerDetector.set(
                    MESSAGE_COUNT.MessageSoundRingerDetector.get() + 1
                );
            } catch (err) {
                dispatch(getMessagesFromCarsStatus(err));
            }
        };
    }
};

const sendMessageToMarshalsServices = (messageId, siteId) => {
    return async (dispatch) => {
        dispatch(sendMessageToMarshalsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.sendMessageToMarshalsApiCall(
                messageId,
                siteId
            );
            let jsonResponse = await response.json();

            if (jsonResponse) {
                dispatch(sendMessageToMarshalsData(jsonResponse));
                dispatch(sendMessageToMarshalsStatus(API_STATUSES.SUCCESS));
            }
        } catch (err) {
            dispatch(sendMessageToMarshalsStatus(err));
        }
    };
};

const getPartialSiteSettingsServices = (siteId) => {
    return async function getPartialSite(dispatch) {
        dispatch(getPartialSiteSettingsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPartialSiteSettingsForUpdateApi(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getPartialSiteSettingsData(jsonResponse));
            dispatch(getPartialSiteSettingsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPartialSiteSettingsStatus(err));
        }
    };
};

const getPackageManifestsServices = () => {
    return async function getPackageManifests(dispatch) {
        dispatch(getPackageManifestsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPackageManifestsApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getPackageManifestsData(jsonResponse));
            dispatch(getPackageManifestsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPackageManifestsStatus(err));
        }
    };
};

const assignManifestToCarsServices = () => {
    return async function assignManifestToCars(dispatch) {
        dispatch(assignManifestToCarsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.assignManifestToCarsApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(assignManifestToCarsData(jsonResponse));
            dispatch(assignManifestToCarsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(assignManifestToCarsStatus(err));
        }
    };
};

const getProgressPendingForSiteServices = (siteId) => {
    return async function getProgressPending(dispatch) {
        dispatch(getProgressPendingForSiteStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getProgressPendingForSiteApi(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getProgressPendingForSiteData(jsonResponse));
            dispatch(getProgressPendingForSiteStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getProgressPendingForSiteStatus(err));
        }
    };
};

const getVersionStringServices = (siteId) => {
    return async function getVersionString(dispatch) {
        dispatch(getVersionStringStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getVersionStringApi(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getVersionStringData(jsonResponse));
            dispatch(getVersionStringStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getVersionStringStatus(err));
        }
    };
};
// ===================================================== Fleet Module Services End ==================================================== //

// ===================================================== Message Module Services Start ==================================================== //

const setSaveEmailApiCall = (payload, siteId) => {
    return async function setSaveEmail(dispatch) {
        dispatch(saveEmailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setSaveEmailApiCall(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(saveEmailData(jsonResponse));
            dispatch(saveEmailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveEmailStatus(err));
        }
    };
};

const setDeleteEmailApiCall = (payload, siteId) => {
    return async function setDeleteEmail(dispatch) {
        dispatch(deleteEmailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setDeleteEmailApiCall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(deleteEmailData(jsonResponse));
            dispatch(deleteEmailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveEmailStatus(err));
        }
    };
};

// get alert message services
const getAlertMessageServices = (siteId) => {
    return async (dispatch) => {
        dispatch(alertMessageStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAlertEmailApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(alertMessageData(jsonResponse));
            dispatch(alertMessageStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(alertMessageStatus(err));
        }
    };
};

// send test message services
const sendTestEmailServices = (payload) => {
    return async (dispatch) => {
        dispatch(sendTestEmailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setSendTestEmailApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(sendTestEmailData(jsonResponse));
            dispatch(sendTestEmailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendTestEmailStatus(err));
        }
    };
};

// Update selected username
const updateEmailServices = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(updateEmailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updateEmailApiCall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(updateEmailData(jsonResponse));
            dispatch(updateEmailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(updateEmailStatus(err));
        }
    };
};

const getMessagesHistoryService = (startDate, endDate, siteId) => {
    return async function getMsgsHistory(dispatch) {
        dispatch(messagesHistoryStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMessagesHistory(
                parseInt(siteId),
                startDate ? startDate : moment(new Date()).format("YYYY-MM-DD"),
                endDate ? endDate : moment(new Date()).format("YYYY-MM-DD"),
                headersConfigData
            );

            let jsonResponse = await response.json();
            dispatch(messagesHistoryData(jsonResponse));
            dispatch(messagesHistoryStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(messagesHistoryStatus(err));
        }
    };
};

//  message / settings / delete message
const deleteMessagesSettingServices = (Id, siteId) => {
    return async (dispatch) => {
        dispatch(deleteMessagesSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteMessagesSettingAPI_CALL(
                Id,
                siteId,
                headersConfigData
            );
            dispatch(deleteMessagesSettingData(response));
            dispatch(deleteMessagesSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteMessagesSettingStatus(err));
        }
    };
};

// message / setting / VDU send
const putMessagesSettingServices = (Id, siteId) => {
    return async (dispatch) => {
        dispatch(putMessagesSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMessagesSettingAPI_CALL(
                Id,
                siteId,
                headersConfigData
            );
            dispatch(putMessagesSettingData(response));
            dispatch(putMessagesSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putMessagesSettingStatus(err));
        }
    };
};

const putMessagesSettingServices2 = (Id, siteId) => {
    return async (dispatch) => {
        dispatch(putMessagesSettingStatus2(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMessagesSettingAPI_CALL2(
                Id,
                siteId,
                headersConfigData
            );
            dispatch(putMessagesSettingData2(response));
            dispatch(putMessagesSettingStatus2(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putMessagesSettingStatus2(err));
        }
    };
};

const putMessagesSettingServices3 = (Id, siteId) => {
    return async (dispatch) => {
        dispatch(setMessageStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMessagesSettingAPI_CALL3(
                Id,
                siteId,
                headersConfigData
            );
            dispatch(setMessageStateAction(response));
            dispatch(setMessageStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setMessageStatusAction(err));
        }
    };
};

//  message / setting / put message  putMessagesSettingServices
const sendMessagesSettingServices = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(sendMessagesSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postCannedMessagesApiCall(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(sendMessagesSettingData(jsonResponse));
            dispatch(sendMessagesSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(sendMessagesSettingStatus(err));
        }
    };
};

const postHoleAreaServices = (payload) => {
    return async (dispatch) => {
        dispatch(postHoleAreaStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postHoleAreaApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(postHoleAreaData(jsonResponse));
            dispatch(postHoleAreaStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(postHoleAreaStatus(err));
        }
    };
};

// message / setting / VDU
const vduGetMessagesSettingServices = (siteId) => {
    return async (dispatch) => {
        dispatch(vduMessagesSettingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getVDUMessagesApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            if (
                jsonResponse.MessageInfo.Messages &&
                !Array.isArray(jsonResponse.MessageInfo.Messages.Message)
            ) {
                jsonResponse.MessageInfo.Messages.Message = [
                    jsonResponse.MessageInfo.Messages.Message,
                ];
            }
            dispatch(vduMessagesSettingData(jsonResponse));
            dispatch(vduMessagesSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(vduMessagesSettingData({}));
            dispatch(vduMessagesSettingStatus(err));
        }
    };
};

// PUT VDU message /setting / VDU
const vduPutMessagesSettingServices = (payload, siteId) => {
    return async (dispatch) => {
        let data = {
            siteId: siteId,
            vduSettings: payload,
        };
        dispatch(vduPutMessagesSettingStatus(true));
        try {
            let response = await API_CALLS.putVDUMessagesApiCall(
                data,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(vduPutMessagesSettingData(jsonResponse));
            dispatch(vduPutMessagesSettingStatus(false));
        } catch (err) {
            dispatch(vduPutMessagesSettingStatus(false));
        }
    };
};
// ===================================================== Message Module Services End ==================================================== //

// ===================================================== Fleet Module Services Start ==================================================== //

const putFleetSettingsServices = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(fleetSettingsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setCurrentSettingApiCall(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            if (jsonResponse) {
                dispatch(fleetSettingslData(jsonResponse));
                dispatch(fleetSettingsStatus(API_STATUSES.SUCCESS));
                dispatch(siteSettingsDataReduxStateAction(jsonResponse));
                dispatch(siteSettingsDataReduxStateStatusAction(API_STATUSES.SUCCESS));
            }
        } catch (err) {
            dispatch(fleetSettingsStatus(err));
        }
    };
};

const putAllowAntiTamperSelectionServices = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(antiTamperSelectionStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putAllowAntiTamperSelectionApiCall(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            if (jsonResponse) {
                dispatch(antiTamperSelectionData(jsonResponse));
                dispatch(antiTamperSelectionStatus(API_STATUSES.SUCCESS));
            }
        } catch (err) {
            dispatch(antiTamperSelectionStatus(err));
        }
    };
};

const putFleetSettingsServices2 = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(fleetSettingsStatus2(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setCurrentSettingApiCall2(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(fleetSettingslData2(jsonResponse));
            dispatch(fleetSettingsStatus2(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(fleetSettingsStatus2(err));
        }
    };
};

//===================================================== Fleet Module Services End  ==================================================== //

// ===================================================== Pins Module Services Start ==================================================== //

const getPinsApproachImagesServices = (siteId, imageName) => {
    return async function getPinsApproachImages(dispatch) {
        dispatch(pinsApproachImagesStateStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPinsApproachImagesApiCall(
                parseInt(siteId),
                imageName,
                headersConfigData
            );
            let imageBlob = await response.blob();
            dispatch(pinsApproachImagesStateDataAction(imageBlob));
            dispatch(setPinsImagesReduxStateDataAction(imageBlob));
            dispatch(pinsApproachImagesStateStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(pinsApproachImagesStateStatusAction(err));
        }
    };
};

const resetPinsApproachImagesServices = () => {
    return async function resetPinsApproachImages(dispatch) {
        dispatch(resetPinsApproachImagesStateDataAction());
    };
};

const resetGetAdImageDataServices = () => {
    return async function resetGetAdImageData(dispatch) {
        dispatch(resetGetAdImageDataAction());
    };
};

const getCarPinPlacementsServices = (siteId) => {
    return async function getCarPinPlacements(dispatch) {
        dispatch(carPinPlacementStateStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarPinPlacementsApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(carPinPlacementStateDataAction(jsonResponse));
            dispatch(carPinPlacementStateStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(carPinPlacementStateStatusAction(err));
        }
    };
};

const updateEzLocatorPinPlacementsServices = (date) => {
    return async function getEzLocatorPinPlacement(dispatch) {
        dispatch(carPinPlacementStateStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updateEzLocatorPins(
                localStorage.getItem("recentSite"),
                localStorage.getItem("courseId"),
                date,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(carPinPlacementStateDataAction(jsonResponse));
            dispatch(carPinPlacementStateStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(carPinPlacementStateStatusAction(err));
        }
    };
};

const getMapInformationServices = (courseNo, holeNo, mapType, siteId) => {
    return async function getMapInformation(dispatch) {
        dispatch(mapInformationStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMapInformationApiCall(
                courseNo,
                holeNo,
                mapType,
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();

            dispatch(mapInformationData(jsonResponse));
            dispatch(mapInformationStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(mapInformationStatus(API_STATUSES.ERROR));
        }
    };
};

const getAllSiteLocationsServices = () => {
    return async function getSiteLoctions(dispatch) {
        dispatch(siteLocationsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAllSiteLocations(headersConfigData);
            let jsonResponse = await response.json();

            dispatch(siteLocationsData(jsonResponse));
            dispatch(siteLocationsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(siteLocationsStatus(API_STATUSES.ERROR));
        }
    };
};

const getAllSiteSetupServices = (siteId) => {
    return async function getSiteSetupData(dispatch) {
        dispatch(siteSetupStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteSetupApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(siteSetupData(jsonResponse));
            dispatch(siteSetupStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(siteSetupStatus(API_STATUSES.ERROR));
        }
    };
};

const setSiteSetupServices = (siteId) => {
    return async function setSiteSetupData() {
        try {
            let response = await API_CALLS.setSiteSetupApiCall(
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();

            return jsonResponse;
        } catch (err) {
            return err;
        }
    };
};

const setTeeSetupServices = (siteId) => {
    return async function setSiteSetupData() {
        try {
            let response = await API_CALLS.setTeeSetupApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            return jsonResponse;
        } catch (err) {
            return err;
        }
    };
};

const setPioSetupServices = (siteId) => {
    return async function setSiteSetupData() {
        try {
            let response = await API_CALLS.setPioSetupApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            return jsonResponse;
        } catch (err) {
            return err;
        }
    };
};

const setPublishSetupServices = (siteId) => {
    return async function setSiteSetupData(dispatch) {
        try {
            let response = await API_CALLS.setPublishSetupApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(publishSetupData(jsonResponse));
            return jsonResponse;
        } catch (err) {
            return err;
        }
    };
};

const getDashboardPaceServices = (siteId, LastQueryDate, courseId) => {
    return async function getDashboardPaceData(dispatch) {
        dispatch(dashboardPaceStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardPaceApiCall(
                headersConfigData,
                siteId,
                LastQueryDate,
                courseId
            );
            let jsonResponse = await response.json();
            dispatch(dashboardPaceData(jsonResponse));
            dispatch(dashboardPaceStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(dashboardPaceStatus(API_STATUSES.ERROR));
        }
    };
};

const getGreensWithPinPlacementsServices = (siteId) => {
    return async function getGreensWithPinPlacements(dispatch) {
        dispatch(greensWithPinPlacementStateStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getGreensWithPinPlacementsApiCall(
                parseInt(siteId),
                courseNumberGetter,
                headersConfigData
            );
            let jsonResponse = await response.json();
            PINS_GLOBAL_STATE.refreshChecker.set(
                PINS_GLOBAL_STATE.refreshChecker.get() + 1
            );
            dispatch(greensWithPinPlacementStateDataAction(jsonResponse));
            let spl = jsonResponse?.RotationSets.filter((item) => item?.Type === "Special");
            if (spl.length <= 0) {
                dispatch(
                    greenWithPinPlacementDataInfoReduxStateAction({
                        rotationType: "specialrotation",
                        value: [],
                    })
                );
            }
            let daily = jsonResponse?.RotationSets.filter((item) => item?.Type === "Daily");
            if (daily.length <= 0) {
                dispatch(
                    greenWithPinPlacementDataInfoReduxStateAction({
                        rotationType: "dailyrotation",
                        value: [],
                    })
                );
            }
            if (jsonResponse?.RotationSets && jsonResponse?.RotationSets.length !== 0) {
                jsonResponse?.RotationSets.forEach((item) => {
                    if (item?.Type === "Daily") {
                        dispatch(
                            greenWithPinPlacementDataInfoReduxStateAction({
                                rotationType: "dailyrotation",
                                value: item?.Rotations,
                            })
                        );
                    }
                });
            }

            if (jsonResponse?.RotationSets && jsonResponse?.RotationSets.length !== 0) {
                jsonResponse?.RotationSets.forEach((item) => {
                    if (item?.Type === "Special") {
                        dispatch(
                            greenWithPinPlacementDataInfoReduxStateAction({
                                rotationType: "specialrotation",
                                value: item?.Rotations,
                            })
                        );
                    }
                });
            }

            if (jsonResponse?.RotationSets && jsonResponse?.RotationSets.length !== 0) {
                jsonResponse?.RotationSets.forEach((item) => {
                    if (item?.ActiveSet === true) {
                        if (item?.Type === "Daily") {
                            dispatch(
                                setSelectedMeasurementPinReduxStateAction(item?.CurrentRotation)
                            );
                            dispatch(
                                setSelectedMeasurementPinBackupReduxStateAction(
                                    item?.CurrentRotation
                                )
                            );
                            dispatch(
                                setSelectedInitialPinReduxStateAction(item?.CurrentRotation)
                            );
                            dispatch(
                                setPrintDataReduxStateAction({
                                    parameterDetector: "rotationName",
                                    value: `${item?.Name} ${item?.CurrentRotation}`,
                                })
                            );
                            PINS_GLOBAL_STATE.cogCheckerForDailyPins.set(item?.ActiveSet);
                        } else if (item?.Type === "Special") {
                            dispatch(
                                setSelectedMeasurementPinReduxStateAction(item?.UserFigure)
                            );
                            dispatch(
                                setSelectedMeasurementPinBackupReduxStateAction(
                                    item?.UserFigure
                                )
                            );

                            dispatch(
                                setPrintDataReduxStateAction({
                                    parameterDetector: "rotationName",
                                    value: `${item?.Name} ${item?.UserFigure}`,
                                })
                            );
                            PINS_GLOBAL_STATE.cogCheckerForSpecialPins.set(item?.ActiveSet);
                        }
                    } else {
                        if (
                            PINS_GLOBAL_STATE.cogCheckerForDailyPins.get() === false &&
                            PINS_GLOBAL_STATE.cogCheckerForSpecialPins.get() === false
                        ) {
                            dispatch(setSelectedMeasurementPinReduxStateAction("cog"));
                            dispatch(setSelectedMeasurementPinBackupReduxStateAction("cog"));
                            dispatch(setSelectedInitialPinReduxStateAction("cog"));
                        }
                    }
                });
            }

            dispatch(greensWithPinPlacementStateStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            PINS_GLOBAL_STATE.refreshChecker.set(0);
            dispatch(greensWithPinPlacementStateStatusAction(API_STATUSES.ERROR));
        }
    };
};

const getRotationDataServices = (siteId, courseNumber) => {
    return async function getRotationData(dispatch) {
        dispatch(getRotationDataStateStatusActions(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRotationDataApiCall(
                parseInt(siteId),
                courseNumber,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getRotationStateDataActions(jsonResponse));
            dispatch(getRotationDataStateStatusActions(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRotationDataStateStatusActions(err));
        }
    };
};

const rotationDataServices = (courseRotationData, serviceType) => {
    return async function rotationData(dispatch) {
        dispatch(rotationDataStatusActions(API_STATUSES.REQUEST, serviceType));
        try {
            let response = await API_CALLS.courseRotationDataApiCall(
                courseRotationData,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(rotationDataActions(jsonResponse, serviceType));
            dispatch(rotationDataStatusActions(API_STATUSES.SUCCESS, serviceType));
        } catch (err) {
            dispatch(rotationDataStatusActions(err, serviceType));
        }
    };
};

const updatePinRotationDataServices = (courseRotationData) => {
    return async function updatePinRotationData(dispatch) {
        dispatch(updatePinRotationStateDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updatePinsRotationsDataApiCall(
                courseRotationData,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(updatePinRotationStateDataAction(jsonResponse));
            dispatch(updatePinRotationStateDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(updatePinRotationStateDataStatusAction(API_STATUSES.ERROR));
        }
    };
};

const courseRotationDaysServices = (courseRotationDaysData) => {
    return async function courseRotationDays(dispatch) {
        dispatch(saveCourseRotationDaysStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveCourseRotationDaysApiCall(
                courseRotationDaysData,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveCourseRotationDaysDataAction(jsonResponse));
            dispatch(saveCourseRotationDaysStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveCourseRotationDaysStatusAction(err));
        }
    };
};

// =====================================================  Pins Module Services End ==================================================== //
// =====================================================  Ads Module Services Start ==================================================== //
const getImageGalleryServices = (siteId) => {
    return async function getImageGallry(dispatch) {
        dispatch(getImageGalleryStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getImageGallaryApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getImageGalleryDataAction(jsonResponse));
            dispatch(getImageGalleryStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getImageGalleryStatusAction(err));
        }
    };
};

const getAdImageServices = (payload2) => {
    const { id } = payload2;

    return async function getAdImage(dispatch) {
        dispatch(getAdImageStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAdImageApiCall(id, headersConfigData);
            let imageBlob = await response.blob();
            let reader = new FileReader();
            reader.readAsDataURL(imageBlob);

            reader.onloadend = () => {
                let base64data = reader.result;
                dispatch(getAdImageDataAction({ base64data, payload2 }));
                dispatch(getAdImageStatusAction(API_STATUSES.SUCCESS));
            };
        } catch (err) {
            dispatch(getAdImageStatusAction(err));
        }
    };
};

const getAdInsertImageServices = (payload2) => {
    const { id } = payload2;

    return async function getAdInsertImage(dispatch) {
        dispatch(getAdInsertImageStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAdImageApiCall(id, headersConfigData);
            let imageBlob = await response.blob();
            let reader = new FileReader();

            reader.readAsDataURL(imageBlob);
            reader.onloadend = () => {
                let base64data = reader.result;
                dispatch(getAdInsertImageDataAction({ base64data, payload2 }));
                dispatch(getAdInsertImageStatusAction(API_STATUSES.SUCCESS));
            };
        } catch (err) {
            dispatch(getAdInsertImageStatusAction(err));
        }
    };
};

const putImageDescriptionServices = (imgData) => {
    const { inputDesc, imgId } = imgData;
    return async function putImageDescription(dispatch) {
        dispatch(putImageDescDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putImageDescriptionAPICall(
                inputDesc,
                imgId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putImageDescDataAction(jsonResponse));
            dispatch(putImageDescDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putImageDescDataStatusAction(err));
        }
    };
};

const deleteImageServices = (imgId) => {
    return async function deleteImage(dispatch) {
        dispatch(deleteImageDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteImageAPICall(
                imgId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(deleteImageDataAction(jsonResponse));
            dispatch(deleteImageDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteImageDataStatusAction(err));
        }
    };
};

const deleteSiteAreaServices = (Id, siteId) => {
    return async function deleteSiteArea(dispatch) {
        dispatch(deleteSiteAreaStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteSiteAreaAPI_CALL(
                Id,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(deleteSiteAreaData(jsonResponse));
            dispatch(deleteSiteAreaStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteSiteAreaStatus(err));
        }
    };
};

const deleteHoleAreaServices = (Id, siteId) => {
    return async function deleteHoleArea(dispatch) {
        dispatch(deleteHoleAreaStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteHoleAreaAPI_CALL(
                Id,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(deleteHoleAreaData(jsonResponse));
            dispatch(deleteHoleAreaStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteHoleAreaStatus(err));
        }
    };
};

const saveCampaignDetailServices = (siteId, payload) => {
    return async function saveCampaignDetail(dispatch) {
        dispatch(saveCampaignDetailStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveCampaignDetailAPICall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveCampaignDetailDataAction(jsonResponse));
            dispatch(saveCampaignDetailStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveCampaignDetailStatusAction(err));
        }
    };
};

const addNewCampaignServices = (siteId) => {
    return async function addNewCampaign(dispatch) {
        dispatch(addNewCampaignStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.addNewCampaignAPICall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(addNewCampaignDataAction(jsonResponse));
            dispatch(addNewCampaignStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(addNewCampaignStatusAction(err));
        }
    };
};

const saveWorksheetServices = (ads) => {
    return async function saveWorksheet(dispatch) {
        dispatch(saveWorksheetStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveWorksheetAPICall(
                ads,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveWorksheetDataAction(jsonResponse));
            dispatch(saveWorksheetStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveWorksheetStatusAction(err));
        }
    };
};

const saveTableCampaignDetailServices = (siteId, payload) => {
    return async function saveTableCampaignDetail(dispatch) {
        dispatch(saveTableCampaignDetailStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveTableCampaignDetailAPICall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveTableCampaignDetailDataAction(jsonResponse));
            dispatch(saveTableCampaignDetailStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveTableCampaignDetailStatusAction(err));
        }
    };
};

const deleteCampaignServices = (Id, siteId) => {
    return async (dispatch) => {
        dispatch(deleteCampaignStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteCampaignAPI_CALL(
                Id,
                headersConfigData,
                siteId
            );
            dispatch(deleteCampaignData(response));
            dispatch(deleteCampaignStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteCampaignStatus(err));
        }
    };
};

const getCampaignsServices = (siteId) => {
    return async function getCampaigns(dispatch) {
        dispatch(getCampaignsStatus(API_STATUSES.REQUEST));

        try {
            let response = await API_CALLS.getCampaignsApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getCampaignsStateData(jsonResponse));
            dispatch(getCampaignsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCampaignsStatus(err));
        }
    };
};

const getBaseCampaignServices = (siteId) => {
    return async function getBaseCampaign(dispatch) {
        dispatch(getBaseCampaignStatusAction(API_STATUSES.REQUEST));

        try {
            let response = await API_CALLS.getBaseCampaignApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getBaseCampaignDataAction(jsonResponse));
            dispatch(getBaseCampaignStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getBaseCampaignStatusAction(err));
        }
    };
};

const copyCampaignsServices = (payload) => {
    return async function copyCampaigns(dispatch) {
        dispatch(copyCampaignsStatus(API_STATUSES.REQUEST));

        try {
            let response = await API_CALLS.copyCampaignAPI_CALL(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(copyCampaignsData(jsonResponse));
            dispatch(copyCampaignsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(copyCampaignsStatus(err));
        }
    };
};

const deleteImagesServices = (payload) => {
    return async function deleteImages(dispatch) {
        dispatch(deleteImagesStatus(API_STATUSES.REQUEST));

        try {
            let response = await API_CALLS.deleteImagesAPI_CALL(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(deleteImagesData(jsonResponse));
            dispatch(deleteImagesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteImagesStatus(err));
        }
    };
};

const deleteMultipleCampaignServices = (payload, siteId) => {
    return async (dispatch) => {
        dispatch(deleteMultipleCampaignStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteMultipleCampaignsAPI(
                payload,
                headersConfigData,
                siteId
            );
            dispatch(deleteMultipleCampaignData(response));
            dispatch(deleteMultipleCampaignStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteMultipleCampaignStatus(err));
        }
    };
};

const getArchiveServices = (campaignId, version) => {
    return async function getArchive(dispatch) {
        dispatch(getArchiveStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getArchiveApiCall(
                version,
                campaignId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getArchiveData(jsonResponse));
            dispatch(getArchiveStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getArchiveStatus(err));
        }
    };
};

const addImageServices = (payload) => {
    return async function addImage(dispatch) {
        dispatch(addImageStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.addImageAPI_CALL(
                payload,
                headersConfigDatafile
            );
            let jsonResponse = await response.json();
            dispatch(addImageData(jsonResponse));
            dispatch(addImageStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(addImageStatus(err));
        }
    };
};

const publishCampaignServices = (payload) => {
    return async function publishCampaign(dispatch) {
        dispatch(publishSiteStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.publishCampaignApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(publishSiteDataAction(jsonResponse));
            dispatch(publishSiteStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(publishSiteStatusAction(err));
        }
    };
};

// =====================================================  Ads Module Services End ==================================================== //
//==============================================Action Zone Module =============================//

const addActionZoneServices = (payload, siteId) => {
    return async function addActionZone(dispatch) {
        dispatch(addActionZoneStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postActionZoneAPI_CALL(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(addActionZoneStateAction(jsonResponse));
            dispatch(addActionZoneStatusAction(API_STATUSES.SUCCESS));
            dispatch(getActionZoneServices(siteId));
            return jsonResponse;
        } catch (err) {
            dispatch(addActionZoneStatusAction(err));
        }
    };
};

const editActionZoneServices = (zoneId, siteId, payload) => {
    return async function editActionZone(dispatch) {
        dispatch(editActionZoneStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putActionZoneAPI_CALL(
                zoneId,
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(editActionZoneStateAction(jsonResponse));
            dispatch(editActionZoneStatusAction(API_STATUSES.SUCCESS));
            dispatch(getActionZoneServices(siteId));
            return jsonResponse;
        } catch (err) {
            dispatch(editActionZoneStatusAction(err));
        }
    };
};

const deleteActionZoneServices = (zoneId, siteId) => {
    return async function deleteActionZone(dispatch) {
        dispatch(deleteActionZoneStatusAction(API_STATUSES.REQUEST));
        try {
            if (zoneId != null) {
                let response = await API_CALLS.deleteActionZoneAPI_CALL(
                    zoneId,
                    headersConfigData,
                    siteId
                );

                let jsonResponse = await response.json();
                dispatch(deleteActionZoneStateAction(jsonResponse));
                dispatch(deleteActionZoneStatusAction(API_STATUSES.SUCCESS));
                dispatch(getActionZoneServices(siteId));
                return jsonResponse;
            }
        } catch (err) {
            dispatch(deleteActionZoneStatusAction(err));
        }
    };
};

//==============================================Action Zone Module =============================//

//============================================== Site Setup Module =============================//
const postSiteAreaServices = (payload) => {
    return async function postSiteArea(dispatch) {
        dispatch(postSiteAreaStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.PostSiteAreaApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(postSiteAreaDataState(jsonResponse));
            dispatch(postSiteAreaStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(postSiteAreaStatus(err));
        }
    };
};

const postTeeMarkerServices = (payload) => {
    return async function postTeeMarker(dispatch) {
        dispatch(teeMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postTeeMarkerAPI_CALL(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(teeMarkerDataStateAction(jsonResponse));
            dispatch(teeMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(teeMarkerStatusAction(err));
        }
    };
};

const deleteTeeMarkerServices = (deleteId, siteId) => {
    return async function deleteTeeMarker(dispatch) {
        dispatch(deleteTeeMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteTeeMarkerAPI_CALL(
                deleteId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(deleteTeeMarkerDataStateAction(jsonResponse));
            dispatch(deleteTeeMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteTeeMarkerStatusAction(err));
        }
    };
};

const postPoiMarkerServices = (payload) => {
    return async function postPoiMarker(dispatch) {
        dispatch(poiMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postPoiMarkerAPI_CALL(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(poiMarkerDataStateAction(jsonResponse));
            dispatch(poiMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(poiMarkerStatusAction(err));
        }
    };
};

const deletePoiMarkerServices = (deleteId, siteId) => {
    return async function deletePoiMarker(dispatch) {
        dispatch(deletePoiMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deletePoiMarkerAPI_CALL(
                deleteId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(deletePoiMarkerDataStateAction(jsonResponse));
            dispatch(deletePoiMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deletePoiMarkerStatusAction(err));
        }
    };
};

const putPoiMarkerServices = (payload, payloadId, siteId) => {
    return async function putPoiMarker(dispatch) {
        dispatch(putPoiMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putPoiMarkerAPI_CALL(
                payload,
                payloadId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putPoiMarkerDataStateAction(jsonResponse));
            dispatch(putPoiMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putPoiMarkerStatusAction(err));
        }
    };
};

const putTeeMarkerServices = (payload, payloadId, siteId) => {
    return async function putTeeMarker(dispatch) {
        dispatch(putTeeMarkerStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putTeeMarkerAPI_CALL(
                payload,
                payloadId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putTeeMarkerDataStateAction(jsonResponse));
            dispatch(putTeeMarkerStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putTeeMarkerStatusAction(err));
        }
    };
};

const getCarBehindPaceDataServices = (siteId, lastQueryDate, courseId) => {
    return async function getCarBehindPaceData(dispatch) {
        dispatch(carBehindPaceDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPaceCarsInfo(
                parseInt(siteId),
                lastQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(carBehindPaceDataStateAction(jsonResponse));
            dispatch(carBehindPaceDataStatusAction(API_STATUSES.SUCCESS));
        } catch (error) {
            dispatch(carBehindPaceDataStatusAction(error));
        }
    };
};

const getDashboardServices = (siteId, courseId, theCurrQueryDate) => {
    return async function getDashboard(dispatch) {
        dispatch(getDashboardStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardApiCall(
                parseInt(siteId),
                courseId,
                theCurrQueryDate,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getDashboardState(jsonResponse));
            dispatch(getDashboardStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getDashboardStatus(err));
        }
    };
};

const getDashboardRidingByCarServices = (
    siteId,
    courseId,
    theCurrQueryDate
) => {
    return async function getDashboardRidingByCar(dispatch) {
        dispatch(getDispatchCarRidingStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardRidingByCar(
                parseInt(siteId),
                courseId,
                theCurrQueryDate,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getDashboardRidingCarState(jsonResponse));
            dispatch(getDispatchCarRidingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getDispatchCarRidingStatus(err));
        }
    };
};

const getWeatherInfoServices = () => {
    return async function getWeatherInfoCaller(dispatch) {
        dispatch(getWeatherInfoDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getWeatherInfo();
            let jsonResponse = await response.json();
            dispatch(getWeatherInfoDataStateAction(jsonResponse));
            dispatch(getWeatherInfoDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getWeatherInfoDataStatusAction(err));
        }
    };
};

const getActionZoneInfractionServices = (date, courseNumId, siteId) => {
    return async function getActionZoneInfraction(dispatch) {
        dispatch(getActionZoneInfractionDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getActionZoneInfractionData(
                parseInt(siteId),
                date,
                courseNumId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getActionZoneInfractionDataStateActon(jsonResponse));
            dispatch(getActionZoneInfractionDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getActionZoneInfractionDataStatusAction(err));
        }
    };
};

const getActionZoneInfractionChildItemServices = (date, actionZoneChild, siteId) => {
    return async function getActionZoneInfractionChildItem(dispatch) {
        dispatch(
            getActionZoneInfractionChildDataStatusAction(API_STATUSES.REQUEST)
        );
        try {
            let response = await API_CALLS.getActionZoneInfractionChildData(
                parseInt(siteId),
                courseNumberGetter,
                date,
                actionZoneChild,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getActionZoneInfractionChildDataStateAction(jsonResponse));
            dispatch(
                getActionZoneInfractionChildDataStatusAction(API_STATUSES.SUCCESS)
            );
        } catch (err) {
            dispatch(getActionZoneInfractionChildDataStatusAction(err));
        }
    };
};

const getCarSelectionServices = (siteId, lastQueryDate, courseId) => {
    return async function getCarSelection(dispatch) {
        dispatch(getCarSelectionStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarSelectionApiCall(
                parseInt(siteId),
                lastQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getCarSelectionStateAction(jsonResponse));
            dispatch(getCarSelectionStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarSelectionStatusAction(err));
        }
    };
};

const getCarBehindPaceCountServices = (siteId, lastQueryDate, courseId) => {
    return async function getCarBehindPaceCount(dispatch) {
        dispatch(getCountCarBehindPaceStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarBehindPaceCountApiCall(
                parseInt(siteId),
                lastQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getCountCarBehindPaceStateAction(jsonResponse));
            dispatch(getCountCarBehindPaceStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCountCarBehindPaceStatusAction(err));
        }
    };
};

const getPaceByHoleServices = (siteId, startDate, endDate) => {
    return async function getPaceByHole(dispatch) {
        dispatch(getPaceByHoleStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPaceByHoleApiCall(
                parseInt(siteId),
                startDate,
                endDate,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getPaceByHoleState(jsonResponse));
            dispatch(getPaceByHoleStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPaceByHoleStatus(err));
        }
    };
};

const getRoundsByDayServices = (
    siteId,
    startDate,
    endDate,
    timeIncrement,
    startTimeHours,
    startTimeMinutes,
    endTimeHours,
    endTimeMinutes
) => {
    return async function getRoundsByDay(dispatch) {
        dispatch(getRoundsByDayStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRoundsByDayApiCall(
                parseInt(siteId),
                startDate,
                endDate,
                timeIncrement,
                startTimeHours,
                startTimeMinutes,
                endTimeHours,
                endTimeMinutes,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getRoundsByDayState(jsonResponse));
            dispatch(getRoundsByDayStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRoundsByDayStatus(err));
        }
    };
};

const getCarMovementServices = (siteId, theCurrQueryDate, courseId) => {
    return async function getCarMovement(dispatch) {
        dispatch(getCarMovementStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarMovementApiCall(
                parseInt(siteId),
                theCurrQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getCarMovementState(jsonResponse));
            dispatch(getCarMovementStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarMovementStatus(err));
        }
    };
};

const getFleetReadinessServices = (siteId, theCurrQueryDate, courseId) => {
    return async function getFleetReadiness(dispatch) {
        dispatch(getFleetReadinessStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFleetReadinessApiCall(
                parseInt(siteId),
                theCurrQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getFleetReadinessState(jsonResponse));
            dispatch(getFleetReadinessStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getFleetReadinessStatus(err));
        }
    };
};

const getRoundsCompletedServices = (siteId, theCurrQueryDate, courseId) => {
    return async function getRoundsCompleted(dispatch) {
        dispatch(getRoundsCompletedStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRoundsCompletedApiCall(
                parseInt(siteId),
                theCurrQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getRoundsCompletedState(jsonResponse));
            dispatch(getRoundsCompletedStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRoundsCompletedStatus(err));
        }
    };
};

const getCarUsageServices = (siteId, includeMemberStatus) => {
    return async function getCarUsage(dispatch) {
        dispatch(getCarUsageStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarUsageApiCall(
                parseInt(siteId),
                includeMemberStatus,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getCarUsageState(jsonResponse));
            dispatch(getCarUsageStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarUsageStatus(err));
        }
    };
};

const getRoundsByCarServices = (
    siteId,
    startDate,
    endDate,
    includeMemberStatus
) => {
    return async function getRoundsByCar(dispatch) {
        dispatch(getRoundsByCarStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRoundsByCarApiCall(
                parseInt(siteId),
                startDate,
                endDate,
                includeMemberStatus,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getRoundsByCarState(jsonResponse));
            dispatch(getRoundsByCarStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRoundsByCarStatus(err));
        }
    };
};

const getRoundsByCarDetailServices = (
    siteId,
    startDate,
    endDate,
    includeMemberStatus
) => {
    return async function getRoundsByCarDetail(dispatch) {
        dispatch(getRoundsByCarDetailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRoundsByCarDetailsApiCall(
                parseInt(siteId),
                startDate,
                endDate,
                includeMemberStatus,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getRoundsByCarDetailState(jsonResponse));
            dispatch(getRoundsByCarDetailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRoundsByCarDetailStatus(err));
        }
    };
};

const getCarUsageDetailServices = (siteId, includeMemberStatus) => {
    return async function getCarUsageDetail(dispatch) {
        dispatch(getCarUsageDetailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCarUsageDetailsApiCall(
                parseInt(siteId),
                includeMemberStatus,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getCarUsageDetailState(jsonResponse));
            dispatch(getCarUsageDetailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getCarUsageDetailStatus(err));
        }
    };
};

const getExportRoundByCarServices = (
    siteId,
    includeMemberCars,
    startDate,
    endDate
) => {
    return async function getExportUsage(dispatch) {
        dispatch(getExportRoundByCarStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getExportRoundByCarApiCall(
                parseInt(siteId),
                includeMemberCars,
                startDate,
                endDate,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getExportRoundByCarState(jsonResponse));
            dispatch(getExportRoundByCarStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getExportRoundByCarStatus(err));
        }
    };
};

const getExportUsageServices = (siteId, includeMemberCars, useKMInstead) => {
    return async function getExportUsage(dispatch) {
        dispatch(getExportUsageStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getExportUsageApiCall(
                parseInt(siteId),
                includeMemberCars,
                useKMInstead,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getExportUsageState(jsonResponse));
            dispatch(getExportUsageStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getExportUsageStatus(err));
        }
    };
};

const getDashboardCampaignAdsServices = (
    siteId,
    currQueryDate,
    courseId
) => {
    return async function getDashboardCampaignAds(dispatch) {
        dispatch(getDashboardCampaignAdsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardCampaignAdsApiCall(
                parseInt(siteId),
                currQueryDate,
                courseId,
                headersConfigDataWelcomeAds
            );

            // let jsonResponse = await response.json();
            if (response.status === 200) {
                let jsonResponse = await response.json();
                dispatch(getDashboardCampaignAdsStateAction(jsonResponse));
                dispatch(getDashboardCampaignAdsStatusAction(API_STATUSES.SUCCESS));
            } else {
                dispatch(getDashboardCampaignAdsStateAction(null));
                dispatch(getDashboardCampaignAdsStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(getDashboardCampaignAdsStatusAction(err));
        }
    };
};

const getDashboardFullImagesServices = (payload2) => {
    const { id } = payload2;

    return async function getAdImage(dispatch) {
        dispatch(getDashboardFullImagesDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAdImageApiCall(
                id,
                headersConfigDataWelcomeAds
            );

            let imageBlob = await response.blob();
            let reader = new FileReader();
            reader.readAsDataURL(imageBlob);

            reader.onloadend = () => {
                let base64data = reader.result;
                dispatch(
                    getDashboardFullImagesDataStateAction({ base64data, payload2 })
                );
                dispatch(getDashboardFullImagesDataStatusAction(API_STATUSES.SUCCESS));
            };
        } catch (err) {
            dispatch(getDashboardFullImagesDataStatusAction(err));
        }
    };
};

const getDashboardInsertImagesServices = (payload2) => {
    const { id } = payload2;
    return async function getAdInsertImage(dispatch) {
        dispatch(getDashboardInsertImagesDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAdImageApiCall(
                id,
                headersConfigDataWelcomeAds
            );

            let imageBlob = await response.blob();
            let reader = new FileReader();
            reader.readAsDataURL(imageBlob);
            reader.onloadend = () => {
                let base64data = reader.result;
                dispatch(
                    getDashboardInsertImagesDataStateAction({ base64data, payload2 })
                );
                dispatch(
                    getDashboardInsertImagesDataStatusAction(API_STATUSES.SUCCESS)
                );
            };
        } catch (err) {
            dispatch(getDashboardInsertImagesDataStatusAction(err));
        }
    };
};

const resetDashboardFUllAdImageDataServices = () => {
    return async function resetDashboardFUllAdImage(dispatch) {
        dispatch(getResetDashboardDataStateAction());
    };
};

const resetDashboardInsertAdImageDataServices = () => {
    return async function resetDashboardInsertAdImage(dispatch) {
        dispatch(getResetInsertDashboardDataStateAction());
    };
};

const getScoreCardServices = (siteId, startDateData, endDateData) => {
    return async function getScoreCard(dispatch) {
        dispatch(getScoreCardStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getScoreCardsApiCall(
                parseInt(siteId),
                moment(startDateData).toISOString(),
                moment(endDateData).endOf("day").toISOString(),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getScoreCardState(jsonResponse));
            dispatch(getScoreCardStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getScoreCardStatus(err));
        }
    };
};
const getEmailAddressesServices = (siteId, startDateData, endDateData) => {
    return async function getEmailAddresses(dispatch) {
        dispatch(getEmailAddressesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getEmailAddressesApiCall(
                parseInt(siteId),
                moment(startDateData).toISOString(),
                moment(endDateData).endOf("day").toISOString(),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getEmailAddressesState(jsonResponse));
            dispatch(getEmailAddressesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getEmailAddressesStatus(err));
        }
    };
};
const putResendEmailServices = (id, siteId, email) => {
    return async function putResendEmail(dispatch) {
        dispatch(putResendEmailStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putResendEmailApiCall(
                id,
                siteId,
                email,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(putResendEmailState(jsonResponse));
            dispatch(putResendEmailStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putResendEmailStatus(err));
        }
    };
};

const getPreRoundCarsServices = (siteId, lastQueryDate, courseId) => {
    return async function getPreRoundCars(dispatch) {
        dispatch(getPreRoundCarsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPreRoundCarsApiCall(
                parseInt(siteId),
                lastQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getPreRoundCarsStateAction(jsonResponse));
            dispatch(getPreRoundCarsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPreRoundCarsStatusAction(err));
        }
    };
};

const getDashboardBatteryNotificationServices = (
    siteId,
    currQueryDate,
    courseId
) => {
    return async function getDashboardBatteryNotification(dispatch) {
        dispatch(getDashboardBatteryNotificationStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardBatteryNotificationApiCall(
                parseInt(siteId),
                currQueryDate,
                courseId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getDashboardBatteryNotificationStateAction(jsonResponse));
            dispatch(
                getDashboardBatteryNotificationStatusAction(API_STATUSES.SUCCESS)
            );
        } catch (err) {
            dispatch(getDashboardBatteryNotificationStatusAction(err));
        }
    };
};

const getSiteAreasServices = (siteId) => {
    return async function getSiteAreas(dispatch) {
        dispatch(getSiteAreasStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteAreasApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getSiteAreasStateAction(jsonResponse));
            dispatch(getSiteAreasStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSiteAreasStatusAction(err));
        }
    };
};

const getHoleAreasServices = (siteId) => {
    return async function getHoleAreas(dispatch) {
        dispatch(getHoleAreasStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getHoleAreasApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(getHoleAreasStateAction(jsonResponse));
            dispatch(getHoleAreasStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getHoleAreasStatusAction(err));
        }
    };
};

const getSingleCarTrackServices = (siteId, gpsiId, hoursBack) => {
    return async function getSingleCarTrack(dispatch) {
        dispatch(getSingleCarTrackStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSingleCarTrackApiCall(
                parseInt(siteId),
                gpsiId,
                hoursBack,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getSingleCarTrackStateAction(jsonResponse));
            dispatch(getSingleCarTrackStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSingleCarTrackStatusAction(err));
        }
    };
};

const getDashboardFeatureSetServices = () => {
    return async function getDashboardFeatureSet(dispatch) {
        dispatch(getDashboardFeatureSetStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getDashboardFeatureSetApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getDashboardFeatureSetStateAction(jsonResponse));
            dispatch(getDashboardFeatureSetStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getDashboardFeatureSetStatusAction(err));
        }
    };
};

const putDashboardFeatureSetServices = (payload) => {
    return async function putDashboardFeatureSet(dispatch) {
        dispatch(putDashboardFeatureSetStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putDashboardFeatureSetApiCall(
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putDashboardFeatureSetStateAction(jsonResponse));
            dispatch(putDashboardFeatureSetStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putDashboardFeatureSetStatusAction(err));
        }
    };
};

const getFeatureSetServices = (siteId) => {
    return async function getFeatureSet(dispatch) {
        dispatch(getFeatureSetStateStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFeatureSetsApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getFeatureSetState(jsonResponse));
            dispatch(getFeatureSetStateStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getFeatureSetStateStatus(err));
        }
    };
};

const setNewFeaturesSetsService = (newFeaturesData, siteId) => {
    return async function setNewFeatures(dispatch) {
        dispatch(setNewFeaturesStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setNewFeatureSetsApiCall(
                newFeaturesData,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(setNewFeaturesStateAction(jsonResponse));
            dispatch(setNewFeaturesStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setNewFeaturesStatusAction(API_STATUSES.ERROR));
        }
    };
};

const saveCourseChangesService = (courseData, siteId) => {
    return async function saveCourseChanges(dispatch) {
        dispatch(setCourseChangesStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveCourseChangesApiCall(
                courseData,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(setCourseChangesResponseAction(jsonResponse));
            dispatch(setCourseChangesStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setCourseChangesStatusAction(API_STATUSES.ERROR));
        }
    };
};

const saveTeeMarkerSettingsService = (teeMarkerId, payloadData, siteId) => {
    return async function saveTeeMarkerSettings(dispatch) {
        dispatch(setTeeMarkerSettingsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putTeeMarkerSettingsApiCall(
                payloadData,
                teeMarkerId,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(setTeeMarkerSettingsDataAction(jsonResponse));
            dispatch(setTeeMarkerSettingsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setTeeMarkerSettingsStatusAction(API_STATUSES.ERROR));
        }
    };
};

const addTeeMarkerSettingsService = (payloadData, siteId) => {
    return async function saveTeeMarkerSettings(dispatch) {
        dispatch(teeMarkerLoaderStatusHandler(true));
        dispatch(addNewTeeMarkerSettingsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postTeeMarkerSettingsApiCall(
                payloadData,
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();
            dispatch(addNewTeeMarkerSettingsDataAction(jsonResponse));
            dispatch(addNewTeeMarkerSettingsStatusAction(API_STATUSES.SUCCESS));
            dispatch(teeMarkerLoaderStatusHandler(false));
        } catch (err) {
            dispatch(addNewTeeMarkerSettingsStatusAction(API_STATUSES.ERROR));
            dispatch(teeMarkerLoaderStatusHandler(false));
        }
    };
};

const putCpoSettingsService = (siteId, payload) => {
    return async function putCpoSettings(dispatch) {
        dispatch(putCpoSettingsStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putCpoSettingsApiCall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(putCpoSettingsStateDataAction(jsonResponse));
            dispatch(putCpoSettingsStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putCpoSettingsStatusAction(API_STATUSES.ERROR));
        }
    };
};

const getCustomerServiceProfile = () => {
    return async function customerService(dispatch) {
        dispatch(setCustomerServiceProfileStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getCustomerServiceProfiles(
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(setCustomerServiceProfileData(jsonResponse));
            dispatch(setCustomerServiceProfileStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setCustomerServiceProfileStatus(err));
        }
    };
};

const saveCustomerServiceProfileSetting = (value, siteId) => {
    return async function saveSettings(dispatch) {
        dispatch(saveCustomerServiceProfileSettingStatus(API_STATUSES.REQUEST));
        try {
            await API_CALLS.saveCustomerServiceProfileSetting(
                value,
                headersConfigData,
                siteId
            );

            let stieData = await API_CALLS.getSiteSettingsApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await stieData.json();

            dispatch(siteSettingsData(jsonResponse));
            dispatch(saveCustomerServiceProfileSettingStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveCustomerServiceProfileSettingStatus(err));
        }
    };
};

const getFoodOrdersDataServices = (startDate, endDate, siteId) => {
    return async function getFoodOrdersData(dispatch) {
        dispatch(getFoodOrdersDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFoodOrdersApiCall(
                headersConfigData,
                siteId,
                startDate,
                endDate
            );
            let jsonResponse = await response.json();

            dispatch(getFoodOrdersDataStateAction(jsonResponse));
            dispatch(getFoodOrdersDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getFoodOrdersDataStatusAction(err));
        }
    };
};

const putFoodEnabledService = (siteId, payload) => {
    return async function putFoodEnabledSettings(dispatch) {
        try {
            let response = await API_CALLS.putFoodEnabledApiCall(
                parseInt(siteId),
                payload,
                headersConfigData
            );
            let jsonResponse = await response.json();

            if (jsonResponse) {
                let stieData = await API_CALLS.getSiteSettingsApiCall(
                    headersConfigData,
                    siteId
                );
                let jsonResponse = await stieData.json();

                dispatch(siteSettingsData(jsonResponse));
            }
        } catch (err) {
            dispatch(siteSettingsStatus(err));
        }
    };
};

const getFoodImageDataServices = (name, siteId) => {
    return async function getFoodImageData(dispatch) {
        dispatch(getFoodImageDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFoodImageApiCall(
                headersConfigData,
                siteId,
                name
            );
            let jsonResponse = await response.json();

            dispatch(getFoodImageDataStateAction(jsonResponse));
        } catch (err) {
            dispatch(getFoodImageDataStatusAction(err));
        }
    };
};

const getFoodImageNamesDataServices = (siteId) => {
    return async function getFoodImageNamesData(dispatch) {
        dispatch(getFoodImageNamesDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFoodImageNamesApiCall(
                headersConfigData,
                siteId
            );

            let jsonResponse = await response.json();

            dispatch(getFoodImageNamesDataStateAction(jsonResponse));
            dispatch(getFoodImageNamesDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getFoodImageNamesDataStatusAction(err));
        }
    };
};

const getFoodOrdersTabServices = (startDate, siteId) => {
    if (window.location.pathname !== "/pins") {
        return async function getFoodOrdersTab(dispatch) {
            dispatch(getFoodOrdersTabDataStatusAction(API_STATUSES.REQUEST));
            try {
                let response = await API_CALLS.getFoodOrdersTabApiCall(
                    headersConfigData,
                    siteId,
                    startDate
                );
                let jsonResponse = await response.json();

                dispatch(getFoodOrdersTabDataStateAction(jsonResponse));
                dispatch(getFoodOrdersTabDataStatusAction(API_STATUSES.SUCCESS));
                dispatch(setNewFoodOrderReduxState(jsonResponse));
                if (FB_GLOBAL_STATES?.foodOrderNotificationCount.get() === 0) {
                    dispatch(setOldFoodOrderReduxState(jsonResponse));
                }
                FB_GLOBAL_STATES?.foodOrderNotificationCount.set(
                    FB_GLOBAL_STATES?.foodOrderNotificationCount.get() + 1
                );
            } catch (err) {
                dispatch(getFoodOrdersTabDataStatusAction(err));
            }
        };
    }
};

const getFoodMenuTabServices = (siteId) => {
    return async function getFoodMenuTab(dispatch) {
        dispatch(getFoodMenuTabDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getFoodMenuTabApiCall(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(getFoodMenuTabDataStateAction(jsonResponse));
            dispatch(getFoodMenuTabDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getFoodMenuTabDataStatusAction(err));
        }
    };
};

const putFoodOrdersTabServices = (order, siteId) => {
    return async function putFoodOrdersTab(dispatch) {
        dispatch(putFoodOrdersTabDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putFoodOrdersTabApiCall(
                headersConfigData,
                siteId,
                order
            );
            let jsonResponse = await response.json();

            dispatch(putFoodOrdersTabDataStateAction(jsonResponse));
            dispatch(putFoodOrdersTabDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putFoodOrdersTabDataStatusAction(err));
        }
    };
};

const putLocalisationServices = (payload, siteId) => {
    return async function putLocalisationTab(dispatch) {
        dispatch(putLocalisationStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putLocalisationTabApiCall(
                payload,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(putLocalisationState(jsonResponse));
            dispatch(putLocalisationStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putLocalisationStatus(err));
        }
    };
};

const putFoodMenuServices = (data, siteId) => {
    return async function putFoodMenu(dispatch) {
        dispatch(putFoodMenuTabDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putFoodMenuApiCall(
                headersConfigData,
                siteId,
                data
            );
            let jsonResponse = await response.json();

            dispatch(putFoodMenuTabDataStateAction(jsonResponse));
            dispatch(putFoodMenuTabDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putFoodMenuTabDataStatusAction(err));
        }
    };
};

const putSharedMenuCheckboxServices = (checkboxData, siteId) => {
    return async function putSharedMenuCheckbox(dispatch) {
        dispatch(setSharedCheckboxSTatusReduxStateAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putSharedMenuCheckboxApiCall(
                checkboxData,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(setSharedCheckboxDataReduxStateAction(jsonResponse));
            dispatch(setSharedCheckboxSTatusReduxStateAction(API_STATUSES.SUCCESS));
        } catch (error) {
            dispatch(setSharedCheckboxSTatusReduxStateAction(API_STATUSES.ERROR));
        }
    };
};

const getValidateZoneTabServices = (siteId) => {
    return async function getValidateZoneTab(dispatch) {
        dispatch(getValidateZoneDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.validateActionZonesForAllSites(
                headersConfigData,
                siteId
            );
            if (response.status === 200) {
                let jsonResponse = await response.json();

                dispatch(getValidateZoneDataStateAction(jsonResponse));
                dispatch(getValidateZoneDataStatusAction(API_STATUSES.SUCCESS));
            } else {
                dispatch(getValidateZoneDataStateAction([]));
                dispatch(getValidateZoneDataStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(getValidateZoneDataStatusAction(err));
        }
    };
};

const getValidatePinTabServices = (siteId) => {
    return async function getValidatePinTab(dispatch) {
        dispatch(getValidatePinDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPinPlacementValidationForAllSites(
                headersConfigData,
                siteId
            );
            if (response.status === 200) {
                let jsonResponse = await response.json();

                dispatch(getValidatePinDataStateAction(jsonResponse));
                dispatch(getValidatePinDataStatusAction(API_STATUSES.SUCCESS));
            } else {
                dispatch(getValidatePinDataStateAction([]));
                dispatch(getValidatePinDataStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(getValidatePinDataStatusAction(err));
        }
    };
};

const getSiteSettingManifestServices = (siteId) => {
    return async function getSiteManifestTab(dispatch) {
        dispatch(getSiteSettingStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteSettingManifest(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getSiteSettingStateAction(jsonResponse));
            dispatch(getSiteSettingStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSiteSettingStatusAction(err));
        }
    };
};

const getPaceManifestServices = (siteId) => {
    return async function getPaceManifestTab(dispatch) {
        dispatch(getPaceManifestStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPaceManifest(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();
            dispatch(getPaceManifestStateAction(jsonResponse));
            dispatch(getPaceManifestStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPaceManifestStatusAction(err));
        }
    };
};

const getMessageManifestServices = (siteId) => {
    return async function getMessageManifestTab(dispatch) {
        dispatch(getMessageManifestStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMessageManifest(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getMessageManifestStateAction(jsonResponse));
            dispatch(getMessageManifestStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getMessageManifestStatusAction(err));
        }
    };
};

const getLanguageManifestServices = (siteId) => {
    return async function getLanguageManifestTab(dispatch) {
        dispatch(getLanguageManifestStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getLanguageManifest(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getLanguageManifestStateAction(jsonResponse));
            dispatch(getLanguageManifestStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getLanguageManifestStatusAction(err));
        }
    };
};

const getSimpleCarManifestServices = (siteId) => {
    return async function getSimpleCarManifestTab(dispatch) {
        dispatch(getSimpleCarManifestStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSimpleCarManifest(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getSimpleCarManifestStateAction(jsonResponse));
            dispatch(getSimpleCarManifestStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSimpleCarManifestStatusAction(err));
        }
    };
};

const getManifestListServices = (siteId) => {
    return async function getSimpleCarManifestTab(dispatch) {
        dispatch(getManifestListStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getManifestList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(getManifestListStateAction(jsonResponse));
            dispatch(getManifestListStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getManifestListStatusAction(err));
        }
    };
};

const saveUsingSharedTeeSettingsService = (payloadData, siteId) => {
    return async function saveUsingSharedTeeSettings(dispatch) {
        dispatch(teeMarkerLoaderStatusHandler(true));
        dispatch(saveSharedTeeMarkerSettingsStatusAction(API_STATUSES.REQUEST));
        try {
            await API_CALLS.saveUsingSharedTeeSettingsApiCall(
                payloadData,
                siteId,
                headersConfigData
            );
            dispatch(saveSharedTeeMarkerSettingsStatusAction(API_STATUSES.SUCCESS));
            dispatch(teeMarkerLoaderStatusHandler(false));
        } catch (error) {
            dispatch(saveSharedTeeMarkerSettingsStatusAction(API_STATUSES.ERROR));
            dispatch(teeMarkerLoaderStatusHandler(false));
        }
    };
};

const deleteTeeSettingsService = (payloadData, siteId) => {
    return async function saveUsingSharedTeeSettings(dispatch) {
        dispatch(teeMarkerLoaderStatusHandler(true));
        dispatch(deleteTeeSettingsStatusAction(API_STATUSES.REQUEST));
        try {
            await API_CALLS.deleteTeeSettingsApiCall(
                payloadData,
                siteId,
                headersConfigData
            );
            dispatch(deleteTeeSettingsStatusAction(API_STATUSES.SUCCESS));
            dispatch(teeMarkerLoaderStatusHandler(false));
        } catch (error) {
            dispatch(deleteTeeSettingsStatusAction(API_STATUSES.ERROR));
            dispatch(teeMarkerLoaderStatusHandler(false));
        }
    };
};

const postChangePasswordService = (payloadData) => {
    return async function postChangePassword(dispatch) {
        dispatch(getChangePasswordStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.postChangePasswordApiCall(
                payloadData,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getChangePasswordStateAction(jsonResponse));
            dispatch(getChangePasswordStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getChangePasswordStatusAction(err));
        }
    };
};

const resetStateChangePasswordService = () => {
    return async function resetStateChangePassword(dispatch) {
        dispatch(resetChangePasswordStateAction());
    };
};

const getSimpleCarListServices = (siteId) => {
    return async function getSimpleCarListTab(dispatch) {
        dispatch(getSimpleCarListStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSimpleCarList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getSimpleCarListState(jsonResponse));
            dispatch(getSimpleCarListStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSimpleCarListStatus(err));
        }
    };
};

const getLanguageListServices = (siteId) => {
    return async function getLanguageListTab(dispatch) {
        dispatch(getLanguageListStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getLanguageList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getLanguageListState(jsonResponse));
            dispatch(getLanguageListStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getLanguageListStatus(err));
        }
    };
};

const getPaceListServices = (siteId) => {
    return async function getPaceListTab(dispatch) {
        dispatch(getPaceListStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPaceList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getPaceListState(jsonResponse));
            dispatch(getPaceListStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPaceListStatus(err));
        }
    };
};

const getMessageListServices = (siteId) => {
    return async function getMessageListTab(dispatch) {
        dispatch(getMessageListStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMessageList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();

            dispatch(getMessageListState(jsonResponse));
            dispatch(getMessageListStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getMessageListStatus(err));
        }
    };
};

const getSiteSettingListServices = (siteId) => {
    return async function getSiteSettingListTab(dispatch) {
        dispatch(getSettingListStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getSiteSettingList(
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.text();
            dispatch(getSettingListState(jsonResponse));
            dispatch(getSettingListStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getSettingListStatus(err));
        }
    };
};

const putHoleDataService = (holeData, siteId) => {
    return async function putHoleData(dispatch) {
        dispatch(putHoleDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putHoleDataApiCall(
                holeData,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();
            dispatch(putHoleDataStateAction(jsonResponse));
            dispatch(putHoleDataStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putHoleDataStatusAction(err));
        }
    };
};

const setAdminCodeService = (siteId) => {
    return async function setAdminCode(dispatch) {
        dispatch(setAdminCodeStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setAdminCodeApiCall(
                parseInt(siteId),
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(setAdminCodeStateAction(jsonResponse));
            dispatch(setAdminCodeStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setAdminCodeStatusAction(err));
        }
    };
};

const uploadKmlService = (payload, siteId) => {
    return async function uploadKmlData(dispatch) {
        dispatch(uploadKmlDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.uploadKmlApiCall(
                payload,
                siteId,
                headersConfigDatafile
            );
            if (response.status === 204) {
                dispatch(uploadKmlDataStatusAction(API_STATUSES.SUCCESS));
            } else {
                dispatch(uploadKmlDataStateAction(response.statusText));
                dispatch(uploadKmlDataStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(uploadKmlDataStatusAction(err));
        }
    };
};

const createHoleMapImageDataService = (siteId) => {
    return async function createHoleMapImageData(dispatch) {
        dispatch(createHoleMapImageDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.createHoleMapImageDataApiCall(
                parseInt(siteId),
                headersConfigData
            );
            if (response.status === 200) {
                let jsonResponse = await response.json();
                dispatch(createHoleMapImageDataStateAction(jsonResponse));
                dispatch(createHoleMapImageDataStatusAction(API_STATUSES.SUCCESS));
            } else if (response.status === 400) {
                let jsonResponse = await response.text();

                dispatch(createHoleMapImageDataStateAction(jsonResponse));
                dispatch(createHoleMapImageDataStatusAction(API_STATUSES.ERROR));
            } else {
                dispatch(createHoleMapImageDataStateAction(response.statusText));
                dispatch(createHoleMapImageDataStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(createHoleMapImageDataStatusAction(err));
        }
    };
};

const processGreenViewZipFileService = (siteId) => {
    return async function processGreenViewData(dispatch) {
        dispatch(processGreenViewDataStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.processGreenViewZipFileApiCall(
                parseInt(siteId),
                headersConfigData
            );

            if (response.status === 200) {
                let jsonResponse = await response.json();
                dispatch(processGreenViewDataStateAction(jsonResponse));
                dispatch(processGreenViewDataStatusAction(API_STATUSES.SUCCESS));
            } else if (response.status === 400) {
                let jsonResponse = await response.text();

                dispatch(processGreenViewDataStateAction(jsonResponse));
                dispatch(processGreenViewDataStatusAction(API_STATUSES.ERROR));
            } else {
                dispatch(processGreenViewDataStateAction(response.statusText));
                dispatch(processGreenViewDataStatusAction(API_STATUSES.ERROR));
            }
        } catch (err) {
            dispatch(processGreenViewDataStatusAction(err));
        }
    };
};

const putMaxVolumeSettingService = (siteSettingData, siteId) => {
    return async function putMaxVolumeSetting(dispatch) {
        dispatch(putMaxVolumeSettingStatusAction(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.putMaxVolumeSettingApiCall(
                siteSettingData,
                headersConfigData,
                siteId
            );
            let jsonResponse = await response.json();

            dispatch(siteSettingsData(jsonResponse));

            dispatch(putMaxVolumeSettingStatusAction(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(putMaxVolumeSettingStatusAction(err));
            dispatch(putMaxVolumeSettingStatusAction(API_STATUSES.ERROR));
        }
    };
};

const getMinVersForNewAZsService = () => {
    return async function getMinVersForNewAZs(dispatch) {
        dispatch(getMinVersForNewAZsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getMinVersForNewAZsServiceApiCall(headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getMinVersForNewAZsData(jsonResponse));

            dispatch(getMinVersForNewAZsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getMinVersForNewAZsStatus(err));
            dispatch(getMinVersForNewAZsStatus(API_STATUSES.ERROR));
        }
    };
};

const publishWaiverTemplateService = (request) => {
    return async function publishWaiverTemplate(dispatch) {
        dispatch(publishWaiverTemplatesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.publishWaiverTemplateApiCall(request, headersConfigData);
            let jsonResponse = await response.json();

            dispatch(publishWaiverTemplatesData(jsonResponse));
            dispatch(publishWaiverTemplatesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(publishWaiverTemplatesStatus(err));
            dispatch(publishWaiverTemplatesStatus(API_STATUSES.ERROR));
        }
    };
};

const saveWaiverTemplateService = (request) => {
    return async function saveWaiverTemplate(dispatch) {
        dispatch(saveWaiverTemplatesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveWaiverTemplateApiCall(
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveWaiverTemplatesData(jsonResponse));
            dispatch(saveWaiverTemplatesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveWaiverTemplatesStatus(err));
            dispatch(saveWaiverTemplatesStatus(API_STATUSES.ERROR));
        }
    };
};

const getWaiverTemplateService = (siteId) => {
    return async function getWaiverTemplate(dispatch) {
        dispatch(getWaiverTemplatesStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getWaiverTemplateApiCall(
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getWaiverTemplatesData(jsonResponse));
            dispatch(getWaiverTemplatesStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getWaiverTemplatesStatus(err));
            dispatch(getWaiverTemplatesStatus(API_STATUSES.ERROR));
        }
    };
};

export const COMMON_SERVICES = {
    putMessagesSettingServices3,
    getSimpleCarListServices,
    getLanguageListServices,
    getPaceListServices,
    getMessageListServices,
    getSiteSettingListServices,
    getWeatherInfoServices,
    saveUsingSharedTeeSettingsService,
    deleteTeeSettingsService,
    putSharedMenuCheckboxServices,
    saveTeeMarkerSettingsService,
    addTeeMarkerSettingsService,
    getRolesListServices,
    getPrivilegesListServices,
    getPrivilegeServices,
    saveCourseChangesService,
    setNewFeaturesSetsService,
    setClickToDriveServices,
    getTodayPinPositionServices,
    getActionZoneInfractionServices,
    getActionZoneInfractionChildItemServices,
    getAuthUserInfoServices,
    getAllSiteLocationsServices,
    getAllSiteSetupServices,
    setSiteSetupServices,
    setTeeSetupServices,
    setPioSetupServices,
    setPublishSetupServices,
    sendMessagesServices,
    getExportRoundByCarServices,
    getCannedMessagesServices,
    getMapImageServices,
    getXYPointsInImageServices,
    getSiteSettingsServices,
    getCarHistoryServices,
    getSpecificCarHistoryServices,
    getAllCarsHistoryServices,
    getUserNameAndRoles,
    sendLinkToEmailForResetPasswordServices,
    changePasswordServices,
    resetPasswordServices,
    resetUsernameServices,
    getCarServices,
    getActionZoneServices,
    getHoleMarkerServices,
    setSaveEmailApiCall,
    getRoundsByCarDetailServices,
    getCarUsageDetailServices,
    setDeleteEmailApiCall,
    getAlertMessageServices,
    sendTestEmailServices,
    getExportUsageServices,
    updateEmailServices,
    getKmlLayerService,
    purCarStagingGuardianModeServices,
    getMessagesHistoryService,
    putFleetSettingsServices,
    putAllowAntiTamperSelectionServices,
    putFleetSettingsServices2,
    getRoundsByDayServices,
    getCarTrackServices,
    getScheduledFleetLockdownServices,
    getSiteOffPeakCharginServices,
    putWelcomeScreenTextMessageServices,
    putCOGDataServices,
    getCarProperties,
    getCarLocation,
    getProductData,
    updateCarType,
    resetSiteDataVersionServices,
    sendMapDataServices,
    sendGreenViewDataServices,
    sendSiteDataServices,
    sendPOIDataServices,
    scheduleSiteDataPublishServices,
    sendTeeMarkerDataServices,
    clearSiteDataServices,
    resetPOIsVersionServices,
    resetMapsVersionServices,
    resetGreenViewVersionServices,
    resetTeeMarkersVersionServices,
    createSiteDataServices,
    resetSiteExtentsAndCtrPtToZeroServices,
    enableAllAZsForMemberCarsServices,
    disableAllAZsForMemberCarsServices,
    deleteHoleAreaServices,
    deleteSiteAreaServices,
    getPinsApproachImagesServices,
    getCarPinPlacementsServices,
    updateEzLocatorPinPlacementsServices,
    getGreensWithPinPlacementsServices,
    deleteMessagesSettingServices,
    getMapInformationServices,
    getRotationDataServices,
    getRoundsByCarServices,
    rotationDataServices,
    courseRotationDaysServices,
    putMessagesSettingServices,
    vduGetMessagesSettingServices,
    vduPutMessagesSettingServices,
    getImageGalleryServices,
    getAdImageServices,
    getAdInsertImageServices,
    sendMessagesSettingServices,
    postHoleAreaServices,
    putSiteAreaDataServices,
    putHoleAreaDataServices,
    getVersionStringServices,
    getProgressPendingForSiteServices,
    getPartialSiteSettingsServices,
    getPackageManifestsServices,
    assignManifestToCarsServices,
    getMessagesFromCarsServices,
    sendMessageToMarshalsServices,
    putRoundTimeOutServices,
    getRoundTimeOutServices,
    putMaxHolesNumService,
    postSavePersistentCarTypeSettingService,
    putRemovePersistentCarTypeSettingService,
    getDashboardCartPathDetailServices,
    putSiteOffPeakChargingServices,
    putUpdateScheduleLockDownServices,
    putUpdateMemberCarTrackingLevelServices,
    putDisableDistanceServices,
    putBehindPaceWarningServices,
    putPaceStatusTimeServices,
    putMaxHoleServices,
    getWelcomeAdsImageServices,
    putScoreCardEmailServices,
    deleteCampaignServices,
    putImageDescriptionServices,
    deleteImageServices,
    getVisageUsersServices,
    getVisageUsersList,
    getCampaignsServices,
    resetPinsApproachImagesServices,
    saveCampaignDetailServices,
    addNewCampaignServices,
    saveWorksheetServices,
    updatePinRotationDataServices,
    copyCampaignsServices,
    deleteImagesServices,
    deleteMultipleCampaignServices,
    saveTableCampaignDetailServices,
    getBaseCampaignServices,
    getArchiveServices,
    addImageServices,
    publishCampaignServices,
    addActionZoneServices,
    editActionZoneServices,
    deleteActionZoneServices,
    resetGetAdImageDataServices,
    postTeeMarkerServices,
    postPoiMarkerServices,
    deleteTeeMarkerServices,
    deletePoiMarkerServices,
    putPoiMarkerServices,
    putTeeMarkerServices,
    getCarBehindPaceDataServices,
    getDashboardServices,
    getDashboardRidingByCarServices,
    postSiteAreaServices,
    getPaceByHoleServices,
    getCarMovementServices,
    getFleetReadinessServices,
    getRoundsCompletedServices,
    getCarSelectionServices,
    getCarUsageServices,
    getCarBehindPaceCountServices,
    getDashboardPaceServices,
    getDashboardCampaignAdsServices,
    getDashboardFullImagesServices,
    getDashboardInsertImagesServices,
    resetDashboardFUllAdImageDataServices,
    resetDashboardInsertAdImageDataServices,
    getScoreCardServices,
    getEmailAddressesServices,
    putResendEmailServices,
    getPreRoundCarsServices,
    getDashboardBatteryNotificationServices,
    getSiteAreasServices,
    getHoleAreasServices,
    getSingleCarTrackServices,
    getDashboardFeatureSetServices,
    putDashboardFeatureSetServices,
    getFeatureSetServices,
    putCpoSettingsService,
    getCustomerServiceProfile,
    saveCustomerServiceProfileSetting,
    getFaultsServices,
    getFoodOrdersDataServices,
    putFoodEnabledService,
    getFoodImageDataServices,
    getFoodImageNamesDataServices,
    getFoodOrdersTabServices,
    putFoodOrdersTabServices,
    putMessagesSettingServices2,
    getFoodMenuTabServices,
    putLocalisationServices,
    putFoodMenuServices,
    getValidateZoneTabServices,
    getValidatePinTabServices,
    getSiteSettingManifestServices,
    getPaceManifestServices,
    getMessageManifestServices,
    getLanguageManifestServices,
    getSimpleCarManifestServices,
    getManifestListServices,
    postChangePasswordService,
    resetStateChangePasswordService,
    putHoleDataService,
    setAdminCodeService,
    uploadKmlService,
    createHoleMapImageDataService,
    processGreenViewZipFileService,
    putMaxVolumeSettingService,
    getMinVersForNewAZsService,
    setSiteExtentsServices,
    publishWaiverTemplateService,
    saveWaiverTemplateService,
    getWaiverTemplateService
};
